(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[16],{

/***/ "56fQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppointmentBookerRoot; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _grandvision_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PM6f");
/* harmony import */ var _grandvision_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ytpp");
/* harmony import */ var _grandvision_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("k3MI");
/* harmony import */ var _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("B4sh");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Y+p1");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Dott");
/* harmony import */ var _grandvision_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("9wPQ");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("bGG1");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("mUC5");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("mUSN");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("glkm");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PDIE");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("n69H");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("vT0N");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("MPu7");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ZTUK");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("2PBL");
/* harmony import */ var _grandvision_stores__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("KOn7");
/* harmony import */ var _grandvision_forms__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("wE1k");
/* harmony import */ var react_swipeable_views__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("7VIw");
/* harmony import */ var react_swipeable_views__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(react_swipeable_views__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("7wYf");
/* harmony import */ var react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _grandvision_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("MZek");
/* harmony import */ var _grandvision_elements__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("m5xE");

















/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/**
 * This custom error can be used for exhaustiveness checks in switch statements
 * over discriminated unions, like the Action type of a state reducer.
 * Exhaustiveness checks help avoid unhandled cases.
 *
 * @example
 *   type State = { foo: string; bar: boolean; baz: number }
 *   type Action =
 *     | { type: 'SET_FOO'; value: string }
 *     | { type: 'TOGGLE_BAR' }
 *     | { type: 'INCREMENT_BAZ' } // <---------------------- newly added
 *   const reducer = (state: State, action: Action) => {
 *     switch (action.type) {
 *       case 'SET_FOO':
 *         return { ...state, foo: action.value }
 *       case 'TOGGLE_BAR':
 *         return { ...state, bar: !state.bar }
 *       default:
 *         throw new UnreachableCase(action)
 *         //                        ^^^^^^
 *         // Argument of type '{ type: "INCREMENT_BAZ" }' is not assignable
 *         // to parameter of type 'never'.
 *     }
 *   }
 */
var UnreachableCase = /** @class */ (function (_super) {
    __extends(UnreachableCase, _super);
    function UnreachableCase(value) {
        return _super.call(this, "Unreachable case: " + JSON.stringify(value)) || this;
    }
    return UnreachableCase;
}(Error));

var formatFromStored = function (state) {
    var formatted = __assign({}, state);
    if (state.selectedDate) {
        formatted.selectedDate = new Date(state.selectedDate);
    }
    if (state.selectedTimeSlot) {
        formatted.selectedTimeSlot = {
            from: new Date(state.selectedTimeSlot.from),
            until: new Date(state.selectedTimeSlot.until),
        };
    }
    if (state.timeFilter) {
        var _a = state.timeFilter, date = _a.date, time = _a.time;
        var formattedDate = __assign({}, date);
        var formattedTime = __assign({}, time);
        switch (date.type) {
            case 'single':
                formattedDate.value = new Date(date.value);
                break;
            case 'range':
                formattedDate.value = {
                    start: new Date(date.value.start),
                    end: new Date(date.value.end),
                };
        }
        if (time.type === 'range') {
            formattedTime.value = {
                start: new Date(time.value.start),
                end: new Date(time.value.end),
            };
        }
        formatted.timeFilter = { date: formattedDate, time: formattedTime };
    }
    return formatted;
};
var isValidState = function (state) {
    if (state === void 0) { state = {}; }
    var customerDetails = state.customerDetails, selectedAppointmentType = state.selectedAppointmentType, selectedStore = state.selectedStore, selectedTimeSlot = state.selectedTimeSlot, typeFilter = state.typeFilter, timeFilter = state.timeFilter;
    var hasValidCustomerDetails = !!customerDetails && typeof customerDetails === 'object';
    var hasValidType = !selectedAppointmentType || (!!selectedAppointmentType.id && !!selectedAppointmentType.name);
    var hasValidTypeFilter = !!typeFilter && typeof typeFilter === 'object';
    var hasValidStore = !selectedStore || !!selectedStore.code;
    var hasValidTimeSlot = !selectedTimeSlot || (!!selectedTimeSlot.from && !!selectedTimeSlot.until);
    var hasValidTimeFilter = !timeFilter ||
        !!(timeFilter.date && timeFilter.date.type && timeFilter.time && timeFilter.time.type);
    try {
        return (hasValidCustomerDetails &&
            hasValidType &&
            hasValidTypeFilter &&
            hasValidStore &&
            hasValidTimeSlot &&
            hasValidTimeFilter);
    }
    catch (e) {
        return false;
    }
};
var isEqualState = function (internalState, storedAppState) {
    // TODO: Expand comparison of states
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default()(internalState, storedAppState);
};
var useStoredAppState = function (initialState) {
    var _a = __read(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* useSessionStorage */ "M"])('appointment', undefined, function (value) { return value === '' || value === null; }), 2), storageValue = _a[0], setStorageValue = _a[1];
    var state = isValidState(storageValue) ? formatFromStored(storageValue) : initialState;
    return [state, setStorageValue];
};

var AppointmentBookerContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});
var AppointmentBookerConsumer = AppointmentBookerContext.Consumer;
var initialState = {
    activeRoute: undefined,
    customerDetails: {
        personalDetails: {},
        billingAddress: {},
    },
    openTimeSearchDialog: false,
    userLocation: undefined,
    typeFilter: {},
    allowOverflow: false,
    timeFilter: {
        date: { type: 'any' },
        time: { type: 'any' },
    },
    hasCompleted: false,
    isRescheduling: false,
    reschedulingFailed: false,
    externalBookingId: undefined,
};
var reducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'RESET':
            return __assign({}, initialState);
        case 'RESET_ACTIVE_ROUTE':
            return __assign(__assign({}, state), { activeRoute: initialState.activeRoute });
        case 'RESET_EXTERNAL_BOOKING_ID':
            return __assign(__assign({}, state), { externalBookingId: initialState.externalBookingId });
        case 'RESET_CUSTOMER_DETAILS':
            return __assign(__assign({}, state), { customerDetails: initialState.customerDetails });
        case 'RESET_SELECTED_APPOINTMENT_TYPE':
            return __assign(__assign({}, state), { selectedAppointmentType: initialState.selectedAppointmentType });
        case 'RESET_SELECTED_STORE':
            return __assign(__assign({}, state), { selectedStore: initialState.selectedStore });
        case 'RESET_SELECTED_DATE':
            return __assign(__assign({}, state), { selectedDate: initialState.selectedDate });
        case 'RESET_SELECTED_TIME_SLOT':
            return __assign(__assign({}, state), { selectedTimeSlot: initialState.selectedTimeSlot });
        case 'RESET_USER_LOCATION':
            return __assign(__assign({}, state), { userLocation: initialState.userLocation });
        case 'RESET_TYPE_FILTER':
            return __assign(__assign({}, state), { typeFilter: initialState.typeFilter });
        case 'RESET_ALLOW_OVERFLOW':
            return __assign(__assign({}, state), { allowOverflow: initialState.allowOverflow });
        case 'RESET_TIME_FILTER':
            return __assign(__assign({}, state), { timeFilter: initialState.timeFilter });
        case 'RESET_HAS_COMPLETED':
            return __assign(__assign({}, state), { hasCompleted: initialState.hasCompleted });
        case 'RESET_RESCHEDULING':
            return state.isRescheduling === initialState.isRescheduling &&
                state.reschedulingFailed === initialState.reschedulingFailed &&
                state.bookedAppointment === undefined
                ? state
                : __assign(__assign({}, state), { isRescheduling: initialState.isRescheduling, reschedulingFailed: initialState.reschedulingFailed, bookedAppointment: undefined });
        case 'RESET_TIME_SEARCH_DIALOG_OPEN':
            return __assign(__assign({}, state), { openTimeSearchDialog: initialState.openTimeSearchDialog });
        case 'RESET_EDIT_PANEL_OPEN':
            return __assign(__assign({}, state), { openEditPanel: initialState.openEditPanel });
        case 'SET_ACTIVE_ROUTE':
            return __assign(__assign({}, state), { activeRoute: action.payload, allowOverflow: false });
        case 'SET_CUSTOMER_DETAILS':
            return __assign(__assign({}, state), { customerDetails: action.payload });
        case 'SET_EXTERNAL_BOOKING_ID':
            return __assign(__assign({}, state), { externalBookingId: action.payload });
        case 'SET_SELECTED_APPOINTMENT_TYPE':
            return __assign(__assign({}, state), { selectedAppointmentType: action.payload });
        case 'SET_SELECTED_STORE':
            return __assign(__assign({}, state), { selectedStore: action.payload });
        case 'SET_SELECTED_DATE':
            return __assign(__assign({}, state), { selectedDate: action.payload });
        case 'SET_SELECTED_TIME_SLOT':
            return __assign(__assign({}, state), { selectedTimeSlot: action.payload });
        case 'SET_USER_LOCATION':
            return __assign(__assign({}, state), { userLocation: action.payload });
        case 'SET_TYPE_FILTER':
            return __assign(__assign({}, state), { typeFilter: action.payload });
        case 'setTypePropertyValue': // @deprecated Use SET_TYPE_FILTER_PROPERTY instead
            console.warn('AppointmentBookerContext "setTypePropertyValue" action is deprecated, use "SET_TYPE_FILTER_PROPERTY" action instead.');
        case 'SET_TYPE_FILTER_PROPERTY':
            return __assign(__assign({}, state), { typeFilter: __assign(__assign({}, state.typeFilter), (_a = {}, _a[action.payload.key] = action.payload.value, _a)) });
        case 'SET_ALLOW_OVERFLOW':
            return __assign(__assign({}, state), { allowOverflow: action.payload });
        case 'SET_TIME_FILTER':
            return __assign(__assign({}, state), { timeFilter: action.payload });
        case 'SET_TIME_SEARCH_DIALOG_OPEN':
            return __assign(__assign({}, state), { openTimeSearchDialog: action.payload });
        case 'SET_EDIT_PANEL_OPEN':
            return __assign(__assign({}, state), { openEditPanel: action.payload });
        case 'SET_HAS_COMPLETED':
            return __assign(__assign({}, state), { hasCompleted: action.payload });
        case 'SET_IS_RESCHEDULING':
            return __assign(__assign({}, state), { isRescheduling: action.payload });
        case 'SET_RESCHEDULING_FAILED':
            return __assign(__assign({}, state), { reschedulingFailed: action.payload });
        case 'SET_BOOKED_APPOINTMENT':
            return __assign(__assign({}, state), { bookedAppointment: action.payload });
        case 'setState': // @deprecated Use specific actions instead
            console.warn("AppointmentBookerContext \"setState\" action is deprecated, use specific actions instead. (Action key: '" + action.key + "' Action value: '" + action.value + "')");
            switch (action.key) {
                case 'activeRoute':
                    return __assign(__assign({}, state), { activeRoute: action.value, allowOverflow: false });
                default:
                    return __assign(__assign({}, state), (_b = {}, _b[action.key] = action.value, _b));
            }
        default:
            throw new UnreachableCase(action);
    }
};
var getBasePathFromAsPath = function (asPath) {
    return (/(?:\/[^\/?]+)/.exec(asPath) || [])[0] || '/';
};
var AppointmentBookerProvider = function (_a) {
    var _b = _a.consents, consents = _b === void 0 ? [] : _b, _c = _a.optIns, optIns = _c === void 0 ? [] : _c, asPath = _a.asPath, initialStateOverride = _a.initialStateOverride, featureToggles = _a.featureToggles, children = _a.children, userData = _a.userData, optInsData = _a.optInsData;
    var _d = __read(useStoredAppState(initialStateOverride || initialState), 2), storedAppState = _d[0], setStoredAppState = _d[1];
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useReducer(reducer, storedAppState), 2), state = _e[0], dispatch = _e[1];
    var basePath = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return getBasePathFromAsPath(asPath); }, [asPath]);
    var value = {
        state: state,
        dispatch: dispatch,
        basePath: basePath,
        consents: consents,
        optIns: optIns,
        featureToggles: featureToggles,
        userData: {
            userData: userData,
            optInsData: optInsData,
        },
        loadingUser: userData.status === 'loading',
    };
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        // If there is sessionStorage, the initialState is being overridden
        if (!isEqualState(state, storedAppState)) {
            setStoredAppState(state);
        }
    }, [state]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentBookerContext.Provider, { value: value, children: children });
};
var useAppointmentBookerContext = function () { return react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(AppointmentBookerContext); };
var AppointmentBookerProvider$1 = Object(_grandvision_auth__WEBPACK_IMPORTED_MODULE_8__[/* WithUserData */ "m"])(AppointmentBookerProvider);

function hasNewQueryParams(stateQueryParams, queryParams) {
    return !lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default()(stateQueryParams, queryParams);
}
function getValidatedRoute(state, route, queryParams) {
    if (queryParams === void 0) { queryParams = {}; }
    var typeId = queryParams.type, storeParam = queryParams.store, storeIdParam = queryParams.storeId, appointmentId = queryParams.appointmentId, rest = __rest(queryParams, ["type", "store", "storeId", "appointmentId"]);
    if (appointmentId) {
        return 'timeslot';
    }
    var typeProperties = typeId ? null : getTypeProperties(rest);
    var hasTypeProperties = typeProperties !== null && Object.entries(typeProperties).length > 0;
    var storeCode = storeParam || storeIdParam
        ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('storeParam || storeIdParam', storeParam || storeIdParam)
        : undefined;
    if (!state ||
        !route ||
        (route !== 'type' && !state.selectedAppointmentType && !typeId && !hasTypeProperties)) {
        return 'type';
    }
    if (route === 'timeslot' && !state.selectedStore && !storeCode) {
        return getValidatedRoute(state, 'store', queryParams);
    }
    if (route === 'details' && !state.selectedTimeSlot && !queryParams.startTime) {
        return getValidatedRoute(state, 'timeslot', queryParams);
    }
    if (route === 'completed' && !state.customerDetails) {
        return getValidatedRoute(state, 'details', queryParams);
    }
    return route;
}
var getTypeProperties = function (queryParams) {
    var regex = /^type_prop-([\w]+)$/;
    return Object.entries(queryParams)
        .filter(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return key.match(regex);
    })
        .reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        acc[key.replace(regex, '$1')] = value;
        return acc;
    }, {});
};
// TODO: split this function so it's testable
var getQueryParamsResults = function (routeOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, queryParams, apiUrl, storeParam, storeIdParam, appointmentId, rest, typeId, typeProperties, hasTypeProperties, promises, storeCode, type, store, bookedAppointment, reschedulingFailed, token, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = routeOptions.queryParams, queryParams = _a === void 0 ? {} : _a, apiUrl = routeOptions.apiUrl;
                storeParam = queryParams.store, storeIdParam = queryParams.storeId, appointmentId = queryParams.appointmentId, rest = __rest(queryParams, ["store", "storeId", "appointmentId"]);
                typeId = queryParams.type;
                typeProperties = typeId ? undefined : getTypeProperties(rest);
                hasTypeProperties = typeProperties && Object.entries(typeProperties).length > 0;
                promises = [];
                storeCode = storeParam || storeIdParam
                    ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('storeParam || storeIdParam', storeParam || storeIdParam)
                    : undefined;
                reschedulingFailed = false;
                if (!appointmentId) return [3 /*break*/, 5];
                if (!apiUrl) {
                    throw new Error('Encountered "appointmentId" query parameter, but no apiUrl was provided');
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, Object(_grandvision_auth__WEBPACK_IMPORTED_MODULE_8__[/* getToken */ "n"])()];
            case 2:
                token = (_b.sent()) || '';
                return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].get(apiUrl, _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('appointmentId', appointmentId), token)];
            case 3:
                bookedAppointment = _b.sent();
                if (bookedAppointment.status !== 'CANCEL') {
                    storeCode = bookedAppointment.store.code.toString();
                    typeId = bookedAppointment.appointmentType.id;
                }
                else {
                    console.error('Cannot reschedule an appointment that has been cancelled.');
                    bookedAppointment = undefined;
                    reschedulingFailed = true;
                }
                return [3 /*break*/, 5];
            case 4:
                err_1 = _b.sent();
                console.error(err_1);
                reschedulingFailed = true;
                return [3 /*break*/, 5];
            case 5:
                if (typeId) {
                    if (!apiUrl) {
                        throw new Error('Encountered "type" query parameter(s), but no apiUrl was provided');
                    }
                    promises.push(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].type(apiUrl, _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('typeId', typeId)).then(function (response) {
                        if (response) {
                            type = response;
                        }
                    }));
                }
                if (hasTypeProperties && typeProperties) {
                    if (!apiUrl) {
                        throw new Error('Encountered "type properties" query parameter(s), but no apiUrl was provided');
                    }
                    promises.push(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].types(apiUrl, typeProperties).then(function (response) {
                        if (response) {
                            type = response[0];
                        }
                    }));
                }
                if (storeCode) {
                    if (!apiUrl) {
                        throw new Error('Encountered "store" query parameter, but no apiUrl was provided');
                    }
                    promises.push(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Stores */ "i"].getDetailsByCode(apiUrl + "/stores", { code: storeCode }).then(function (response) {
                        if (response) {
                            store = __assign(__assign({}, response), { slots: [] });
                        }
                    }));
                }
                return [4 /*yield*/, Promise.all(promises)];
            case 6:
                _b.sent();
                return [2 /*return*/, { typeProperties: typeProperties, type: type, store: store, bookedAppointment: bookedAppointment, reschedulingFailed: reschedulingFailed }];
        }
    });
}); };
// TODO: split this function so it's testable
/**
 * This hook was introduced to handle client side routing, in separation of the next routing.
 * Using next routing, a PageModel will be requested for the nested pages (which don't exist),
 * breaking the application. In order to make this work, we have to use the history api, without
 * triggering next (e.g. when clicking back in the browser). By maintaining a static url property
 * within the state object provided to the history api, next assumes the page remains the same.
 * We do change the "as" property to represent the correct value in the address bar. This will not
 * trigger a routing action from the next router.
 *
 * The hook supports handling routes by either "pushState" or "replaceState" (e.g. when a route is
 * not valid according to current app state) and is capable of handling route changes triggered by
 * "onpopstate" events.
 *
 * Logic for listening to onpopstate (overriding default next router behaviour) and for route
 * validation is implemented at application level outside of this hook (but tightly coupled), and
 * should utilise the setActiveRoute setter when required. This ensures re-usability of this hook
 * in different places.
 */
var useRouteState = function () {
    var _a = useAppointmentBookerContext(), state = _a.state, dispatch = _a.dispatch, basePath = _a.basePath;
    var activeRoute = state.activeRoute;
    var setActiveRoute = function (route, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var method, _a, typeProperties, type, store, bookedAppointment, reschedulingFailed, _b, queryParams, cancelled, queryString, as;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        method = options.replace ? 'replaceState' : 'pushState';
                        return [4 /*yield*/, getQueryParamsResults(options)];
                    case 1:
                        _a = _c.sent(), typeProperties = _a.typeProperties, type = _a.type, store = _a.store, bookedAppointment = _a.bookedAppointment, reschedulingFailed = _a.reschedulingFailed;
                        _b = options.queryParams, queryParams = _b === void 0 ? {} : _b, cancelled = options.cancelled;
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        if (queryParams.time_search === 'true') {
                            dispatch({
                                type: 'SET_TIME_SEARCH_DIALOG_OPEN',
                                payload: true,
                            });
                        }
                        if (typeProperties) {
                            Object.entries(typeProperties).forEach(function (_a) {
                                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                return dispatch({
                                    type: 'SET_TYPE_FILTER_PROPERTY',
                                    payload: { key: key, value: value },
                                });
                            });
                        }
                        if (type) {
                            dispatch({
                                type: 'SET_SELECTED_APPOINTMENT_TYPE',
                                payload: type,
                            });
                            if (type.additionalTags && Object.keys(type.additionalTags).length > 0) {
                                Object.entries(type.additionalTags).forEach(function (_a) {
                                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                    dispatch({
                                        type: 'SET_TYPE_FILTER_PROPERTY',
                                        payload: { key: key, value: value },
                                    });
                                });
                            }
                        }
                        if (store) {
                            dispatch({
                                type: 'SET_SELECTED_STORE',
                                payload: store,
                            });
                        }
                        dispatch({
                            type: 'SET_ACTIVE_ROUTE',
                            payload: route,
                        });
                        dispatch({
                            type: 'RESET_TIME_SEARCH_DIALOG_OPEN',
                        });
                        dispatch({
                            type: 'RESET_EDIT_PANEL_OPEN',
                        });
                        if (bookedAppointment) {
                            dispatch({
                                type: 'SET_IS_RESCHEDULING',
                                payload: true,
                            });
                            dispatch({
                                type: 'SET_BOOKED_APPOINTMENT',
                                payload: bookedAppointment,
                            });
                        }
                        if (reschedulingFailed) {
                            dispatch({ type: 'SET_RESCHEDULING_FAILED', payload: true });
                        }
                        if (options.fromPopState || typeof history === 'undefined') {
                            return [2 /*return*/];
                        }
                        queryString = _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* QueryString */ "e"].stringify(queryParams);
                        as = "" + basePath + (route ? "/" + route + queryString : '');
                        if (history.state.as === as) {
                            return [2 /*return*/];
                        }
                        history[method]({
                            as: as,
                            url: basePath,
                        }, route || '', as);
                        return [2 /*return*/];
                }
            });
        });
    };
    return [activeRoute, setActiveRoute];
};

/**
 * Appointments
 */
var AppointmentAction;
(function (AppointmentAction) {
    AppointmentAction["New"] = "new";
    AppointmentAction["Change"] = "change";
    AppointmentAction["Cancel"] = "cancel";
})(AppointmentAction || (AppointmentAction = {}));
// Maps routes to step names
var AppointmentFunnelStepName;
(function (AppointmentFunnelStepName) {
    AppointmentFunnelStepName["type"] = "select type";
    AppointmentFunnelStepName["store"] = "find store";
    AppointmentFunnelStepName["timeslot"] = "select time slot";
    AppointmentFunnelStepName["details"] = "contact details";
    AppointmentFunnelStepName["completed"] = "confirmation";
    AppointmentFunnelStepName["edit"] = "edit";
    AppointmentFunnelStepName["searchStoreForTime"] = "find store for time slot";
    AppointmentFunnelStepName["searchTime"] = "select time filter";
})(AppointmentFunnelStepName || (AppointmentFunnelStepName = {}));

var getStepName = function (route) {
    return route && AppointmentFunnelStepName[route];
};
var appointmentFunnelStepNames = Object.values(AppointmentFunnelStepName);
var appointmentActions = Object.values(AppointmentAction);
var formatDateWithTimezoneOffset = function (date) {
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(date, "yyyy-MM-dd'T'HH:mm:ssXXX");
};
var isAppointmentFunnelStepName = function (stepName) { return appointmentFunnelStepNames.includes(stepName); };
var isAppointmentAction = function (action) {
    return appointmentActions.includes(action);
};
function createAppointmentStore(store) {
    return {
        id: store.code.toString(),
        name: store.storeName,
        address: store.streetName + " " + (store.additionalStreetInfo || '') + " " + (store.streetNumber || ''),
        postalCode: store.postalCode,
        city: store.town,
    };
}
function createAppointmentFunnelModel(stepName) {
    if (!isAppointmentFunnelStepName(stepName)) {
        console.warn("Tried to create dataLayer appointmentFunnel model with invalid step name: " + name);
        return;
    }
    var id = appointmentFunnelStepNames.indexOf(stepName) + 1;
    return {
        version: 'AAB 1.0',
        step: {
            name: stepName,
            id: id.toString(),
        },
    };
}
function createAppointmentModel(_a) {
    var action = _a.action, type = _a.type, typeDetails = _a.typeDetails, store = _a.store, selectedTimeFilter = _a.selectedTimeFilter, startTime = _a.startTime, endTime = _a.endTime;
    if (!isAppointmentAction(action)) {
        console.warn("Tried to create dataLayer appointment model with invalid action: " + action);
        return;
    }
    return {
        action: action,
        type: type,
        typeDetails: typeDetails,
        selectedTimeFilter: selectedTimeFilter,
        store: store,
        startTime: startTime ? formatDateWithTimezoneOffset(startTime) : undefined,
        endTime: endTime ? formatDateWithTimezoneOffset(endTime) : undefined,
    };
}
function createAppointmentEvent(action, route, appointmentType, typeFilter, store, timeSlot) {
    var stepName = getStepName(route);
    var appointmentFunnel = createAppointmentFunnelModel(stepName || '');
    var appointmentStore = store && createAppointmentStore(store);
    var appointment = createAppointmentModel({
        action: action,
        type: appointmentType ? appointmentType.name : undefined,
        typeDetails: typeFilter,
        store: appointmentStore,
        startTime: timeSlot ? timeSlot.from : undefined,
        endTime: timeSlot ? timeSlot.until : undefined,
    });
    // If one of these objects is undefined, invalid data was provided so we should not create the event
    if (!appointmentFunnel || !appointment) {
        return undefined;
    }
    return {
        event: 'aab_step',
        appointmentFunnel: appointmentFunnel,
        appointment: appointment,
    };
}

var pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
var parseLocalDateTime = function (input) {
    if (!pattern.test(input)) {
        throw new Error("Invalid local datetime string: " + input);
    }
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(input);
};

function shiftDate(date, period, amount) {
    if (amount === void 0) { amount = 1; }
    switch (period) {
        case 'day':
            return Object(date_fns__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(date, amount);
        case 'week':
            return Object(date_fns__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(date, amount);
        case 'month':
            return Object(date_fns__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(date, amount);
        case 'year':
            return Object(date_fns__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(date, amount);
    }
}

var dateToDayNumberMonthYearString = function (date) {
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(date, 'EEEE d MMMM, yyyy');
};
var dateToLocalTime = function (date, timeFormat) {
    if (timeFormat === void 0) { timeFormat = '24h'; }
    return timeFormat === 'amPm' ? Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(date, 'h:mma') : Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(date, 'H:mm');
};
var datesToLocalTimeSpan = function (from, until, timeFormat) {
    if (timeFormat === void 0) { timeFormat = '24h'; }
    return dateToLocalTime(from, timeFormat) + " - " + dateToLocalTime(until, timeFormat);
};
var isSameMinute = function (date1, date2) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(date1, date2); };
var isSameDay = function (date1, date2) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(date1, date2); };
var isDateBefore = function (date1, date2) {
    return new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0);
};
var isWithinTimeSpan = function (date, start, end) {
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(date, { start: start, end: end });
};
/**
 * Serialize a Date as a local ISO8601 datetime string. Like Date.prototype.toISOString,
 * but in the local timezone and without the timezone offset.
 */
var toLocalDateTime = function (date) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(date, "yyyy-MM-dd'T'HH:mm:ss"); };
/**
 * Serialize a Date as a local ISO8601 date string. Like Date.prototype.toISOString,
 * but in the local timezone and just the date, no time or timezone offset.
 */
var toLocalDate = function (date) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(date, 'yyyy-MM-dd'); };
var eachDay = function (start, end) { return Object(date_fns__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])({ start: start, end: end }); };
var getDateListFromDate = function (date, size) {
    if (size === void 0) { size = 7; }
    return eachDay(date, shiftDate(date, 'day', size - 1));
};

var useDateRangeProvider = function (from) {
    if (from === void 0) { from = new Date(); }
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (index) { return getDateListFromDate(shiftDate(from, 'week', index)); }, []);
};

var useTimeFilterString = function () {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])(), getLabel = _a.getLabel, _b = _a.dateTime, formatDate = _b.formatDate, formatTime = _b.formatTime;
    var timeFilter = useAppointmentBookerContext().state.timeFilter;
    var date = timeFilter.date, time = timeFilter.time;
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        var dateString = '';
        var timeString = '';
        switch (date.type) {
            case 'single':
                dateString = formatDate(date.value, 'short');
                break;
            case 'range':
                dateString = formatDate(date.value.start, 'short') + " - " + formatDate(date.value.end, 'short');
                break;
            case 'dynamic':
                var today = new Date();
                var value = date.value === 'today' ? today : shiftDate(today, 'day');
                dateString = formatDate(value, 'short');
        }
        if (time.type === 'range') {
            timeString = formatTime(time.value.start) + " - " + formatTime(time.value.end);
        }
        return "" + dateString + (dateString && timeString ? " " + getLabel('appointments.infoBar.from') + " " : '') + timeString;
    }, [date, time]);
};

var useTimeSlots = function (apiUrl, options) {
    if (options === void 0) { options = { skip: false }; }
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(null), 2), query = _a[0], setQuery = _a[1];
    var skip = options.skip;
    var opts = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({
        skip: skip || query === null || !query.appointmentTypeId || !query.storeCode || !query.startDate,
    }); }, [skip, query]);
    var _b = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].timeSlots, opts, apiUrl, query), 3), loading = _b[0], data = _b[1], error = _b[2];
    return { query: query, setQuery: setQuery, loading: loading, data: data, error: error };
};

var InfoBar = function (_a) {
    var className = _a.className, context = _a.context, details = _a.details, _b = _a.detailsScale, detailsScale = _b === void 0 ? 'regular' : _b, onEdit = _a.onEdit, rest = __rest(_a, ["className", "context", "details", "detailsScale", "onEdit"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().getLabel;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('info-bar', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "info-bar__meta" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "info-bar__context" }, context),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('info-bar__details', {
                    'info-bar__details--small': detailsScale === 'small',
                }) }, details)),
        onEdit && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", { className: "info-bar__edit", onClick: onEdit }, getLabel('appointments.infoBar.edit')))));
};

var useInfoBarState = function () {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var _a = useAppointmentBookerContext(), appState = _a.state, dispatch = _a.dispatch;
    var activeRoute = appState.activeRoute, type = appState.selectedAppointmentType, store = appState.selectedStore, reschedulingFailed = appState.reschedulingFailed;
    var showEditButton = !reschedulingFailed && activeRoute !== 'type';
    var onEdit = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return showEditButton ? function () { return dispatch({ type: 'SET_EDIT_PANEL_OPEN', payload: true }); } : undefined;
    }, [showEditButton]);
    var timeFilterString = useTimeFilterString();
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        if (store) {
            return {
                context: (type && type.name) || '',
                details: store ? store.storeName : '',
                detailsScale: 'small',
                onEdit: onEdit,
            };
        }
        if (timeFilterString) {
            return {
                context: (type && type.name) || '',
                details: timeFilterString,
                detailsScale: 'small',
                onEdit: onEdit,
            };
        }
        return {
            context: intl.getLabel('appointments.infoBar.context'),
            details: (type && type.name) || '',
            onEdit: onEdit,
        };
    }, [store, type, timeFilterString, onEdit]);
};
var InfoBarContainer = function (props) {
    var infoBarState = useInfoBarState();
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(InfoBar, __assign({}, props, infoBarState));
};

var getAvailability = function (store) {
    return store && store.slots && store.slots !== 'loading' ? store.slots.length : 0;
};

var byDistance = function (a, b) {
    return typeof a.distance !== 'number' || typeof b.distance !== 'number' ? 0 : a.distance - b.distance;
};
var byAvailabilityAndDistance = function (a, b) { return Number(getAvailability(b) > 0) - Number(getAvailability(a) > 0) || byDistance(a, b); };

var getDateWithZeroTime = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
};
var getDateWithMaxedTime = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
};
var getAlignedDate = function (date, targetDate) {
    return new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};
var isSlotWithinDateFilter = function (slot, filter, now // Mostly for testing purposes
) {
    if (now === void 0) { now = new Date(); }
    var from = slot.from, until = slot.until;
    switch (filter.type) {
        case 'single':
            return isSameDay(filter.value, from) && isSameDay(filter.value, until);
        case 'dynamic':
            switch (filter.value) {
                case 'today':
                    return isSameDay(now, from) && isSameDay(now, until);
                case 'tomorrow':
                    var tomorrow = shiftDate(now, 'day', 1);
                    return isSameDay(tomorrow, from) && isSameDay(tomorrow, until);
                default:
                    throw new UnreachableCase(filter.value);
            }
        case 'range':
            var _a = filter.value, start = _a.start, end = _a.end;
            var rangeStart = getDateWithZeroTime(start);
            var rangeEnd = getDateWithMaxedTime(end);
            return (isWithinTimeSpan(from, rangeStart, rangeEnd) &&
                isWithinTimeSpan(until, rangeStart, rangeEnd));
        case 'any':
            return true;
        default:
            throw new UnreachableCase(filter);
    }
};
var isSlotWithinTimeFilter = function (slot, filter) {
    switch (filter.type) {
        case 'range':
            var from = slot.from, until = slot.until;
            var _a = filter.value, start = _a.start, end = _a.end;
            if (!isSameDay(start, end)) {
                throw new Error('Time filter start and end should be on the same date');
            }
            return (isWithinTimeSpan(getAlignedDate(from, start), start, end) &&
                isWithinTimeSpan(getAlignedDate(until, end), start, end));
        case 'any':
            return true;
        default:
            throw new UnreachableCase(filter);
    }
};
var isSlotWithinFilter = function (slot, filter) {
    var dateFilter = filter.date, timeFilter = filter.time;
    return isSlotWithinDateFilter(slot, dateFilter) && isSlotWithinTimeFilter(slot, timeFilter);
};
var getSlotsByTimeFilter = function (slots, filter) {
    return slots.filter(function (slot) { return isSlotWithinFilter(slot, filter); });
};
var getSlotMapRequestStartAndEndByTimeFilter = function (filter, now) {
    if (now === void 0) { now = new Date(); }
    var dateFilter = filter.date;
    var slotMapStart;
    var slotMapEnd;
    switch (dateFilter.type) {
        case 'single':
            slotMapStart = dateFilter.value;
            slotMapEnd = dateFilter.value;
            break;
        case 'dynamic':
            switch (dateFilter.value) {
                case 'today':
                    slotMapStart = now;
                    slotMapEnd = now;
                    break;
                case 'tomorrow':
                    var tomorrow = shiftDate(now, 'day', 1);
                    slotMapStart = tomorrow;
                    slotMapEnd = tomorrow;
                    break;
                default:
                    throw new UnreachableCase(dateFilter.value);
            }
            break;
        case 'range':
            slotMapStart = dateFilter.value.start;
            slotMapEnd = dateFilter.value.end;
            break;
        case 'any':
            slotMapStart = now;
            slotMapEnd = shiftDate(now, 'day', 6);
            break;
        default:
            throw new UnreachableCase(dateFilter);
    }
    return [toLocalDate(slotMapStart), toLocalDate(slotMapEnd)];
};
var timeSlotResponseToTimeSlots = function (timeSlots) {
    return timeSlots.map(function (_a) {
        var from = _a.from, until = _a.until;
        return ({
            from: parseLocalDateTime(from),
            until: parseLocalDateTime(until),
        });
    });
};
var timeSlotsByDay = function (timeSlots) {
    return timeSlots
        .sort(function (a, b) { return a.from.getTime() - b.from.getTime(); })
        .reduce(function (accumulator, timeSlot) {
        var lastCollection = accumulator[accumulator.length - 1] || [];
        var collectionDay = lastCollection[lastCollection.length - 1] || null;
        if (!collectionDay || !isSameDay(collectionDay.from, timeSlot.from)) {
            accumulator.push([timeSlot]);
        }
        else {
            lastCollection.push(timeSlot);
        }
        return accumulator;
    }, []);
};

var useSlotData = function (apiUrl, appointmentId, startDate, endDate, stores, skip) {
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(null), 2), slotRequest = _a[0], setSlotRequest = _a[1];
    var slotRequestOptions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({ skip: skip || !slotRequest }); }, [
        skip,
        slotRequest,
    ]);
    var _b = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState({}), 2), slotMap = _b[0], setSlotMap = _b[1];
    var _c = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(true), 2), isLoading = _c[0], setIsLoading = _c[1];
    var _d = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].timeSlotsForStores, slotRequestOptions, apiUrl, slotRequest), 3), slotDataLoading = _d[0], slotData = _d[1], slotDataError = _d[2];
    var reset = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        setSlotRequest(null);
        setSlotMap({});
        setIsLoading(false);
    }, []);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(reset, [appointmentId]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!slotDataLoading) {
            setIsLoading(false);
        }
    }, [slotDataLoading]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (skip) {
            return;
        }
        var didChange = false;
        var updatedSlots = __spread((slotRequest ? slotRequest.storeCodes : []));
        stores.forEach(function (_a) {
            var code = _a.code;
            if (updatedSlots.includes(code) || slotMap[code]) {
                return;
            }
            didChange = true;
            updatedSlots.push(code);
        });
        if (didChange) {
            setIsLoading(true);
            setSlotRequest({
                storeCodes: updatedSlots,
                appointmentTypeId: appointmentId,
                startDate: startDate,
                endDate: endDate,
            });
        }
    }, [appointmentId, startDate, endDate, stores, slotMap, slotRequest]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!skip && slotRequest && !slotDataLoading && !slotDataError && slotData && slotData.length) {
            var updatedSlotMap_1 = __assign({}, slotMap);
            slotData.forEach(function (slots, index) {
                updatedSlotMap_1[slotRequest.storeCodes[index]] = slots.map(function (_a) {
                    var from = _a.from, until = _a.until;
                    return ({
                        from: parseLocalDateTime(from),
                        until: parseLocalDateTime(until),
                    });
                });
            });
            setSlotMap(updatedSlotMap_1);
            setSlotRequest(null);
        }
    }, [slotMap, slotRequest, slotDataLoading, slotData, slotDataError]);
    return [isLoading, slotMap, slotDataError, reset];
};

var DEFAULT_FILTER_COUNT = 5;
var initialReducerState = {
    filterCount: DEFAULT_FILTER_COUNT,
    filterQuery: '',
    active: null,
    hovered: null,
    location: null,
};
var reducer$1 = function (state, action) {
    switch (action.type) {
        case 'RESET_STORE_CONTEXT':
            return __assign({}, initialReducerState);
        case 'RESET_STORE_FILTER_COUNT':
            return __assign(__assign({}, state), { filterCount: DEFAULT_FILTER_COUNT });
        case 'RESET_STORE_FILTER_QUERY':
            return __assign(__assign({}, state), { filterCount: DEFAULT_FILTER_COUNT, filterQuery: '' });
        case 'RESET_ACTIVE_STORE':
            return __assign(__assign({}, state), { active: null });
        case 'RESET_HOVERED_STORE':
            return __assign(__assign({}, state), { hovered: null });
        case 'RESET_LOCATION':
            return __assign(__assign({}, state), { location: null });
        case 'CHANGE_STORE_FILTER_COUNT':
            return __assign(__assign({}, state), { filterCount: action.payload });
        case 'LOAD_MORE':
            return __assign(__assign({}, state), { filterCount: state.filterCount + DEFAULT_FILTER_COUNT });
        case 'CHANGE_STORE_FILTER_QUERY':
            return __assign(__assign({}, state), { filterCount: DEFAULT_FILTER_COUNT, filterQuery: action.payload, active: null, location: null });
        case 'SET_ACTIVE_STORE':
            return __assign(__assign({}, state), { active: action.payload, filterCount: DEFAULT_FILTER_COUNT, filterQuery: '', location: null });
        case 'SET_HOVERED_STORE':
            return __assign(__assign({}, state), { hovered: action.payload });
        case 'SET_LOCATION':
            return __assign(__assign({}, state), { location: action.payload, active: null });
        default:
            throw new UnreachableCase(action);
    }
};
// TODO: Remove once the open / close props have become optional
function normalizeApiStore(entry, slotMap, timeFilter, withSlots) {
    var slots = slotMap ? slotMap[entry.code] || 'loading' : 'loading';
    return __assign(__assign({}, entry), { mondayOpenClose: entry.mondayOpenClose || [], tuesdayOpenClose: entry.tuesdayOpenClose || [], wednesdayOpenClose: entry.wednesdayOpenClose || [], thursdayOpenClose: entry.thursdayOpenClose || [], fridayOpenClose: entry.fridayOpenClose || [], saturdayOpenClose: entry.saturdayOpenClose || [], sundayOpenClose: entry.sundayOpenClose || [], slots: withSlots ? (slots === 'loading' ? slots : getSlotsByTimeFilter(slots, timeFilter)) : [] });
}
var StoresContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});
var StoresConsumer = StoresContext.Consumer;
var useStoresContext = function () { return react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(StoresContext); };
var StoresProvider = function (_a) {
    var apiUrl = _a.apiUrl, initialStateOverride = _a.initialStateOverride, searchWhitelist = _a.searchWhitelist, children = _a.children;
    var _b = useAppointmentBookerContext(), appState = _b.state, dispatchAppAction = _b.dispatch, withAvailabilityOnStoreSelection = _b.featureToggles.withAvailabilityOnStoreSelection;
    var selectedAppointmentType = appState.selectedAppointmentType, selectedStore = appState.selectedStore, selectedDate = appState.selectedDate, userLocation = appState.userLocation, activeRoute = appState.activeRoute, timeFilter = appState.timeFilter, openEditPanel = appState.openEditPanel;
    var _c = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useReducer(reducer$1, __assign(__assign({}, (initialStateOverride || initialReducerState)), { active: selectedStore || null })), 2), storesState = _c[0], dispatchStoresAction = _c[1];
    var filterCount = storesState.filterCount, filterQuery = storesState.filterQuery, active = storesState.active, location = storesState.location;
    var _d = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(active), 2), initialActive = _d[0], setInitialActive = _d[1];
    var hasActiveFilters = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return Boolean(active || location || filterQuery || userLocation); }, [active, location, filterQuery, userLocation]);
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(new Date()), 2), date = _e[0], setDate = _e[1];
    var _f = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return getSlotMapRequestStartAndEndByTimeFilter(timeFilter, date); }, [timeFilter, date]), 2), slotRequestStart = _f[0], slotRequestEnd = _f[1];
    var _g = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState([]), 2), slotMapStores = _g[0], setSlotMapStores = _g[1];
    var activeStoreSearch = Boolean(activeRoute === 'timeslot' && selectedDate && openEditPanel);
    var activeTimeSearch = hasActiveFilters &&
        ['store'].includes(activeRoute) &&
        (timeFilter.date.type !== 'any' || timeFilter.time.type !== 'any');
    var allowSlotUsage = Boolean(withAvailabilityOnStoreSelection || activeTimeSearch || activeStoreSearch);
    var skipSlotRequests = !selectedAppointmentType || !allowSlotUsage;
    var _h = __read(useSlotData(apiUrl, selectedAppointmentType ? selectedAppointmentType.id : '', slotRequestStart, slotRequestEnd, slotMapStores, skipSlotRequests), 4), loadingSlots = _h[0], slotMap = _h[1], loadSlotsError = _h[2], resetSlotMap = _h[3];
    var _j = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Stores */ "i"].list, null, apiUrl + "/stores"), 3), loadingStores = _j[0], storesData = _j[1], loadingStoresError = _j[2];
    var list = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return (storesData || []).map(function (entry) {
            return normalizeApiStore(entry, slotMap, timeFilter, allowSlotUsage);
        });
    }, [storesData, slotMap, timeFilter, allowSlotUsage]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (['store', 'timeslot'].includes(activeRoute) && selectedStore) {
            dispatchStoresAction({ type: 'SET_ACTIVE_STORE', payload: selectedStore });
        }
    }, [activeRoute, selectedStore]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!['store', 'timeslot'].includes(activeRoute)) {
            dispatchStoresAction({ type: 'RESET_STORE_CONTEXT' });
            resetSlotMap();
        }
    }, [activeRoute]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return resetSlotMap(); }, [timeFilter]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        return setInitialActive(function (oldValue) {
            if ((!active && oldValue) || (active && !oldValue)) {
                return active;
            }
            return oldValue;
        });
    }, [active]);
    var referencePosition = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        if (userLocation) {
            return { lat: userLocation.lat, lon: userLocation.lng };
        }
        if (selectedStore && activeRoute !== 'store') {
            return { lat: selectedStore.lat, lon: selectedStore.lon };
        }
        if (initialActive) {
            return { lat: initialActive.lat, lon: initialActive.lon };
        }
        if (location) {
            return { lat: location.position.lat, lon: location.position.lng };
        }
        return {
            lat: undefined,
            lon: undefined,
        };
    }, [userLocation, selectedStore, initialActive, location, activeRoute]);
    var filtered = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        if (!hasActiveFilters) {
            return withAvailabilityOnStoreSelection ? [] : list;
        }
        var items = filterQuery
            ? list.filter(function (store) { return _grandvision_stores__WEBPACK_IMPORTED_MODULE_19__[/* Util */ "f"].searchStore(store, filterQuery, searchWhitelist); })
            : list;
        var options = {
            limit: filterCount,
        };
        var nearestStores = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* findNearestCoordinates */ "j"])(referencePosition, items, options);
        return allowSlotUsage ? nearestStores.sort(byAvailabilityAndDistance) : nearestStores;
    }, [
        hasActiveFilters,
        list,
        filterQuery,
        filterCount,
        initialActive,
        referencePosition,
        searchWhitelist,
    ]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (allowSlotUsage) {
            setSlotMapStores(filtered);
        }
    }, [filtered]);
    var value = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return {
            state: __assign(__assign({ loadingStores: loadingStores,
                loadingSlots: loadingSlots }, storesState), { list: list,
                filtered: filtered,
                allowSlotUsage: allowSlotUsage }),
            dispatch: dispatchStoresAction,
        };
    }, [
        loadingStores,
        loadingSlots,
        storesState,
        list,
        filtered,
        allowSlotUsage,
        dispatchStoresAction,
    ]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoresContext.Provider, { value: value }, children);
};

var StoreSummary = function (_a) {
    var className = _a.className, store = _a.store, _b = _a.availability, availability = _b === void 0 ? 0 : _b, _c = _a.showAvailability, showAvailability = _c === void 0 ? false : _c, _d = _a.showAvailabilityCount, showAvailabilityCount = _d === void 0 ? false : _d, _e = _a.showDistance, showDistance = _e === void 0 ? true : _e, rest = __rest(_a, ["className", "store", "availability", "showAvailability", "showAvailabilityCount", "showDistance"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var distance = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* hasDistance */ "t"])(store) && store.distance > 0 && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* formatDistance */ "k"])(store.distance, intl.distanceUnit);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, {
            'store-summary': true,
            'store-summary--available-slots': availability > 0,
            'store-summary--with-availability': showAvailability,
        }) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-summary__name" }, store.storeName),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-summary__address" }, 
        /* TODO: Format address according to locale */ (store.streetNumber || '') + " " + store.streetName + ", " + store.town),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-summary__meta" },
            showAvailability && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-summary__availability" },
                showAvailabilityCount && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-summary__availability-count" }, availability)),
                intl.getLabel(availability > 0
                    ? 'appointments.storeSummary.slotsAvailable'
                    : 'appointments.storeSummary.slotsUnavailable'))),
            showDistance && distance && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-summary__distance" }, distance))));
};

var InfoWindowComponent = function (props) {
    var _a;
    var store = props.store, availability = props.availability, showAvailability = props.showAvailability, showAvailabilityCount = props.showAvailabilityCount, showDistance = props.showDistance;
    var storesContext = useStoresContext();
    var hovered = storesContext.state.hovered;
    return ((_a = hovered === null || hovered === void 0 ? void 0 : hovered.store) === null || _a === void 0 ? void 0 : _a.code) === store.code && hovered.marker ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* InfoWindow */ "A"], { anchor: hovered.marker },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSummary, { store: store, availability: availability, showAvailability: showAvailability, showAvailabilityCount: showAvailabilityCount, showDistance: showDistance }))) : null;
};

var getSvgString = function (width, height, theme) {
    return "<svg width=\"" + width + "px\" height=\"" + height + "px\" viewBox=\"0 0 27 39\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27 13.4727C27 20.9135 15.1096 39 13.5 39C11.8904 39 0 20.9135 0 13.4727C0 6.03195 6.04416 0 13.5 0C20.9558 0 27 6.03195 27 13.4727Z\" fill=\"" + theme.background + "\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.2849 9.21942C8.50005 9.00663 8.84887 9.00663 9.06402 9.21942L14.1837 14.2829L19.3034 9.21942C19.5186 9.00663 19.8674 9.00663 20.0825 9.21942C20.2977 9.4322 20.2977 9.7772 20.0825 9.98998L14.9628 15.0534L20.0825 20.1169C20.2977 20.3296 20.2977 20.6746 20.0825 20.8874C19.8674 21.1002 19.5186 21.1002 19.3034 20.8874L14.1837 15.824L9.06402 20.8874C8.84887 21.1002 8.50005 21.1002 8.2849 20.8874C8.06975 20.6746 8.06975 20.3296 8.2849 20.1169L13.4046 15.0534L8.2849 9.98998C8.06975 9.7772 8.06975 9.4322 8.2849 9.21942Z\" fill=\"" + theme.foreground + "\"/></svg>";
};
var UnavailablePin = function (_a) {
    var _b = _a.width, defaultWidth = _b === void 0 ? 27 : _b, _c = _a.height, defaultHeight = _c === void 0 ? 39 : _c, themes = _a.themes;
    return function (props) {
        var primaryTheme = themes.primary, highlightTheme = themes.highlight;
        var _a = props.highlight, highlight = _a === void 0 ? false : _a;
        var theme = highlight && highlightTheme ? highlightTheme : primaryTheme;
        var width = theme.width || defaultWidth;
        var height = theme.height || defaultHeight;
        var anchor = new google.maps.Point(Math.round(width / 2), height);
        var size = new google.maps.Size(width, height);
        var svgString = getSvgString(width, height, theme);
        return {
            url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString),
            anchor: anchor,
            size: size,
            scaledSize: size,
        };
    };
};

var getSvgString$1 = function (width, height, theme) {
    return "<svg width=\"" + width + "px\" height=\"" + height + "px\" viewBox=\"0 0 31 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"15.6\" cy=\"15.6\" r=\"13.5\" style=\"opacity:0.3;fill:" + theme.background + ";\"/><circle cx=\"15.6\" cy=\"15.6\" r=\"7.5\" style=\"fill:" + theme.foreground + ";stroke:#FFFFFF;stroke-width:2;\"/></svg>";
};
var UserPin = function (_a) {
    var _b = _a.width, defaultWidth = _b === void 0 ? 31 : _b, _c = _a.height, defaultHeight = _c === void 0 ? 31 : _c, themes = _a.themes;
    return function (props) {
        var primaryTheme = themes.primary, highlightTheme = themes.highlight;
        var _a = props.highlight, highlight = _a === void 0 ? false : _a;
        var theme = highlight && highlightTheme ? highlightTheme : primaryTheme;
        var width = theme.width || defaultWidth;
        var height = theme.height || defaultHeight;
        var anchor = new google.maps.Point(Math.round(width / 2), height);
        var size = new google.maps.Size(width, height);
        var svgString = getSvgString$1(width, height, theme);
        return {
            url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString),
            anchor: anchor,
            size: size,
            scaledSize: size,
        };
    };
};

var loadingPin = UnavailablePin({
    width: 0,
    height: 0,
    themes: {
        primary: { foreground: 'transparent', background: 'transparent' },
        highlight: { foreground: 'transparent', background: 'transparent', width: 0, height: 0 },
    },
});
var disabledPin = UnavailablePin({
    width: 28,
    height: 40,
    themes: {
        primary: { foreground: '#ffffff', background: '#b3b3b3' },
        highlight: { foreground: '#ffffff', background: '#b3b3b3', width: 44, height: 64 },
    },
});
var userPin = UserPin({
    themes: {
        primary: { foreground: '#00a4e4', background: '#a5caf3' },
    },
});
var getMarkers = function (stores, _a) {
    var _b = _a === void 0 ? {} : _a, pin = _b.pin, userLocation = _b.userLocation, _c = _b.checkAvailability, checkAvailability = _c === void 0 ? true : _c, _d = _b.showAvailability, showAvailability = _d === void 0 ? false : _d, _e = _b.showAvailabilityCount, showAvailabilityCount = _e === void 0 ? false : _e, hoveredStore = _b.hoveredStore;
    var storeMarkers = stores
        .filter(function (store) { return typeof store.lat === 'number' && typeof store.lon === 'number'; })
        .map(function (store) { return ({
        code: store.code,
        position: {
            lat: store.lat,
            lng: store.lon,
        },
        pin: store.slots === 'loading'
            ? loadingPin
            : !checkAvailability || store.slots.length
                ? pin
                : disabledPin,
        infoWindow: (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(InfoWindowComponent, { store: store, availability: (checkAvailability && store.slots.length) || 0, showAvailability: showAvailability, showAvailabilityCount: showAvailabilityCount, showDistance: Boolean(userLocation) })),
    }); });
    var userMarker = userLocation
        ? [
            {
                position: userLocation,
                pin: userPin,
            },
        ]
        : [];
    return __spread(storeMarkers, userMarker);
};
var getCenter = function (googleMapsMapCenter, markers, highlight, userLocation, activeLocation) {
    if (markers.length && highlight) {
        var marker = markers.find(function (marker) { return marker.code === highlight; });
        if (marker) {
            return marker.position;
        }
        return markers.length === 1 ? markers[0].position : googleMapsMapCenter;
    }
    else if (activeLocation) {
        return activeLocation.position;
    }
    else if (userLocation) {
        return userLocation;
    }
    else if (markers.length === 1) {
        return markers[0].position;
    }
    return googleMapsMapCenter;
};

var defaultSettings = {
    enableHighAccuracy: true,
    timeout: Infinity,
    maximumAge: 0,
};
var usePosition = function (watch, settings) {
    if (watch === void 0) { watch = false; }
    if (settings === void 0) { settings = defaultSettings; }
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var _a = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(undefined), 2), position = _a[0], setPosition = _a[1];
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(null), 2), error = _b[0], setError = _b[1];
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false), 2), useMyLocation = _c[0], setUseMyLocation = _c[1];
    var onChange = function (_a) {
        var coords = _a.coords, timestamp = _a.timestamp;
        setPosition({
            lat: coords.latitude,
            lng: coords.longitude,
            accuracy: coords.accuracy,
            timestamp: timestamp,
        });
    };
    var onError = function (error) {
        console.warn('Failed to get user coords:', error.message);
        switch (error.code) {
            case error.PERMISSION_DENIED:
                setError(intl.getLabel('stores.yourLocation.permissionDenied'));
                _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].warning('stores.yourLocation.permissionDenied');
                break;
            default:
                setError(intl.getLabel('stores.yourLocation.error'));
                _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].warning('stores.yourLocation.error');
        }
    };
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
        if (useMyLocation) {
            var hasBrowserSupport = typeof window !== 'undefined' &&
                typeof window.navigator !== 'undefined' &&
                typeof window.navigator.geolocation !== 'undefined';
            if (!hasBrowserSupport) {
                setError(intl.getLabel('stores.yourLocation.error'));
                _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].warning('stores.yourLocation.error');
                return;
            }
            var geo_1 = window.navigator.geolocation;
            var watcher_1 = null;
            if (watch) {
                watcher_1 = geo_1.watchPosition(onChange, onError, settings);
            }
            else {
                geo_1.getCurrentPosition(onChange, onError, settings);
            }
            return function () { return watcher_1 && geo_1.clearWatch(watcher_1); };
        }
    }, [settings, useMyLocation]);
    return { position: position, useMyLocation: useMyLocation, setUseMyLocation: setUseMyLocation, error: error };
};

var initialState$1 = {
    showMap: null,
    markers: [],
    highlight: null,
    center: { lat: 0, lng: 0 },
    userLocation: undefined,
    useUserLocation: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setUseUserLocation: function (useUserLocation) { },
    useUserLocationError: null,
};
var reducer$2 = function (state, action) {
    // TODO: Implement actions
    switch (action) {
        default:
            return state;
    }
};
var MapContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});
var MapConsumer = MapContext.Consumer;
var useMapContext = function () { return react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(MapContext); };
var MapProvider = function (_a) {
    var initialStateOverride = _a.initialStateOverride, children = _a.children;
    var _b = Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* useGoogleMapsContext */ "wb"])(), defaultCenter = _b.defaultCenter, pin = _b.pin;
    var _c = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useReducer(reducer$2, initialStateOverride || initialState$1), 2), mapState = _c[0], dispatchMapAction = _c[1];
    var _d = useAppointmentBookerContext(), appState = _d.state, dispatchAppAction = _d.dispatch;
    var _e = useStoresContext(), storesState = _e.state, dispatchStoresAction = _e.dispatch;
    var _f = usePosition(true), userLocation = _f.position, useUserLocation = _f.useMyLocation, setUseUserLocation = _f.setUseMyLocation, useUserLocationError = _f.error;
    var activeRoute = appState.activeRoute;
    var filteredStores = storesState.filtered, activeStore = storesState.active, hoveredStore = storesState.hovered, activeLocation = storesState.location, allowSlotUsage = storesState.allowSlotUsage;
    var markers = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return getMarkers(filteredStores, {
            userLocation: useUserLocation ? userLocation : undefined,
            checkAvailability: allowSlotUsage,
            showAvailability: allowSlotUsage,
            showAvailabilityCount: allowSlotUsage,
            hoveredStore: hoveredStore,
            pin: pin,
        });
    }, [filteredStores, hoveredStore, useUserLocation, userLocation]);
    var highlight = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return (activeStore ? activeStore.code : null); }, [activeStore]);
    var center = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return getCenter(defaultCenter, markers, highlight, useUserLocation ? userLocation || null : null, activeLocation);
    }, [defaultCenter, markers, highlight, useUserLocation, userLocation, activeLocation]);
    var showMap = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return activeRoute !== 'details' && activeRoute !== 'completed'; }, [
        activeRoute,
    ]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        return dispatchAppAction({
            type: 'setState',
            key: 'userLocation',
            value: useUserLocation && userLocation
                ? { lat: userLocation.lat, lng: userLocation.lng }
                : undefined,
        });
    }, [useUserLocation, userLocation]);
    var state = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return (__assign(__assign({}, mapState), { showMap: showMap, markers: activeRoute === 'type' ? [] : markers, highlight: activeRoute === 'type' ? null : highlight, center: center,
        userLocation: userLocation,
        useUserLocation: useUserLocation,
        setUseUserLocation: setUseUserLocation,
        useUserLocationError: useUserLocationError })); }, [
        activeRoute,
        mapState,
        showMap,
        markers,
        highlight,
        center,
        userLocation,
        useUserLocation,
        setUseUserLocation,
        useUserLocationError,
    ]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MapContext.Provider, { value: { state: state, dispatch: dispatchMapAction }, children: children });
};

var MapView = function (_a) {
    var className = _a.className, center = _a.center, highlight = _a.highlight, markers = _a.markers, onSelectMarker = _a.onSelectMarker, userLocation = _a.userLocation, _b = _a.showUseMyLocation, showUseMyLocation = _b === void 0 ? false : _b, onMapClick = _a.onMapClick, onMarkerHover = _a.onMarkerHover, onClickUseMyLocation = _a.onClickUseMyLocation, view = _a.view, withZoom = _a.withZoom, rest = __rest(_a, ["className", "center", "highlight", "markers", "onSelectMarker", "userLocation", "showUseMyLocation", "onMapClick", "onMarkerHover", "onClickUseMyLocation", "view", "withZoom"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('map-view', "map-view--" + view, { 'map-view--with-markers': markers.length > 0 }, className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* GoogleMaps */ "t"], { markers: markers, center: center, highlight: highlight, onMarkerClick: onSelectMarker, showUseMyLocation: showUseMyLocation, onClickUseMyLocation: onClickUseMyLocation, userLocation: userLocation, onMapClick: onMapClick, onMarkerHover: onMarkerHover, mapOptions: { zoomControl: withZoom } })));
};

var MapViewContainer = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var _b = useAppointmentBookerContext(), appState = _b.state, dispatchAppAction = _b.dispatch;
    var mapState = useMapContext().state;
    var _c = useStoresContext(), storesState = _c.state, dispatchStoresAction = _c.dispatch;
    var _d = __read(useRouteState(), 2), activeRoute = _d[0], setActiveRoute = _d[1];
    var selectedStore = appState.selectedStore, userLocation = appState.userLocation;
    var markers = mapState.markers, center = mapState.center, setUseUserLocation = mapState.setUseUserLocation;
    var storeList = storesState.list, allowSlotUsage = storesState.allowSlotUsage;
    var onSelectMarker = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (code) {
        var store = storeList.find(function (store) { return store.code === code; }) || null;
        if (['store', 'timeslot'].includes(activeRoute) &&
            store &&
            (!allowSlotUsage || (store.slots !== 'loading' && store.slots.length > 0))) {
            dispatchAppAction({ type: 'setState', key: 'selectedStore', value: store });
            setActiveRoute('timeslot');
        }
    }, [storeList, activeRoute]);
    var onMarkerHover = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (code, markerRef) {
        var store = (code && storesState.list.find(function (store) { return store.code === code; })) || null;
        dispatchStoresAction({
            type: 'SET_HOVERED_STORE',
            payload: {
                store: store,
                marker: markerRef,
            },
        });
    }, [storeList]);
    var onClickUseMyLocation = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        dispatchStoresAction({ type: 'RESET_ACTIVE_STORE' });
        dispatchStoresAction({ type: 'RESET_STORE_FILTER_QUERY' });
        setUseUserLocation(true);
    }, [setUseUserLocation]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MapView, __assign({}, rest, { center: center, highlight: selectedStore ? selectedStore.code : null, markers: markers, onSelectMarker: onSelectMarker, onMarkerHover: onMarkerHover, showUseMyLocation: true, onClickUseMyLocation: onClickUseMyLocation, userLocation: userLocation, view: "fullscreen", withZoom: true })));
};

// Would have loved to name this BookAppointment, but it already exists within @grandvision/forms/BookAppointment :(
var AppointmentBooker = function (_a) {
    var className = _a.className, apiUrl = _a.apiUrl, isFullScreen = _a.isFullScreen, showMap = _a.showMap, showInfoBar = _a.showInfoBar, confirmationImageUrl = _a.confirmationImageUrl, children = _a.children, rest = __rest(_a, ["className", "apiUrl", "isFullScreen", "showMap", "showInfoBar", "confirmationImageUrl", "children"]);
    var _b = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(false), 2), isMounted = _b[0], setIsMounted = _b[1];
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return setIsMounted(true); }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('appointment-booker', { 'appointment-booker--fullscreen': isFullScreen }, className) }),
        isMounted && isFullScreen && showMap && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MapViewContainer, null),
        isMounted && isFullScreen && !showMap && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "appointment-booker__confirmation-image", style: {
                backgroundImage: "url(" + confirmationImageUrl + ")",
            } })),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "appointment-booker__contents" },
            showInfoBar && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(InfoBarContainer, null),
            isMounted && children)));
};

var AppointmentSummary = function (_a) {
    var className = _a.className, type = _a.type, store = _a.store, timeSlot = _a.timeSlot, rest = __rest(_a, ["className", "type", "store", "timeSlot"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('appointment-summary', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("ul", { className: "appointment-summary__parts" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { className: "appointment-summary__part appointment-summary__type" }, (type && type.name) || ''),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { className: "appointment-summary__part appointment-summary__date" }, timeSlot ? dateToDayNumberMonthYearString(timeSlot.from) : ''),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { className: "appointment-summary__part appointment-summary__time" }, timeSlot ? datesToLocalTimeSpan(timeSlot.from, timeSlot.until) : ''),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { className: "appointment-summary__part appointment-summary__store" }, store ? store.town + " - " + store.streetName : ''))));
};

var AppointmentSummaryContainer = function (_a) {
    var rest = __rest(_a, []);
    var state = useAppointmentBookerContext().state;
    var selectedAppointmentType = state.selectedAppointmentType, selectedStore = state.selectedStore, selectedTimeSlot = state.selectedTimeSlot;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentSummary, __assign({}, rest, { type: selectedAppointmentType, store: selectedStore, timeSlot: selectedTimeSlot })));
};

var DirectionsButton = function (_a) {
    var store = _a.store, userLocation = _a.userLocation, rest = __rest(_a, ["store", "userLocation"]);
    var onClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        var origin = userLocation
            ? "&origin=" + encodeURIComponent(userLocation.lat + ", " + userLocation.lng)
            : '';
        var destination = "&destination=" + encodeURIComponent(store.streetName && store.streetNumber && store.town && store.country
            ? store.streetName + " " + store.streetNumber + ", " + store.town + ", " + store.country
            : store.lat + ", " + store.lon);
        window.open("https://www.google.com/maps/dir/?api=1" + origin + destination, '_blank');
    }, [store, userLocation]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], __assign({}, rest, { onClick: onClick }));
};

var generateIcsEvent = function (_a) {
    var title = _a.title, description = _a.description, location = _a.location, start = _a.start, end = _a.end;
    // Do not change indenting, it will break the format
    return "// BEGIN:VCALENDAR\n// VERSION:2.0\n// BEGIN:VEVENT\n// CLASS:PUBLIC\n// DESCRIPTION:" + description + "\n// DTSTART:" + Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(start, "yyyyMMdd'T'HHmmss") + "\n// DTEND:" + Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(end, "yyyyMMdd'T'HHmmss") + "\n// LOCATION:" + location + "\n// SUMMARY:" + title + "\n// TRANSP:TRANSPARENT\n// END:VEVENT\n// END:VCALENDAR\n// UID:grandvision/" + start.getTime() + "\n// DTSTAMP:" + Object(date_fns__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(new Date(), "yyyyMMdd'T'HHmmss") + "\n// PRODID:grandvision/appointment";
};
var generateIcsBlob = function (icsEvent) { return new Blob([icsEvent], { type: 'text/calendar' }); };
var generateIcsUrl = function (icsBlob) { return URL.createObjectURL(icsBlob); };

var ICSButton = function (_a) {
    var appointmentType = _a.appointmentType, timeSlot = _a.timeSlot, store = _a.store, rest = __rest(_a, ["appointmentType", "timeSlot", "store"]);
    var onClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        var icsEvent = generateIcsEvent({
            title: appointmentType.name,
            description: appointmentType.description || '',
            location: store.town + " - " + store.streetName + " " + store.streetNumber,
            start: timeSlot.from,
            end: timeSlot.until,
        });
        var icsBlob = generateIcsBlob(icsEvent);
        window.navigator.msSaveOrOpenBlob
            ? window.navigator.msSaveOrOpenBlob(icsBlob, 'appointment') // IE11
            : window.open(generateIcsUrl(icsBlob), '_blank'); // Evergreen
    }, [appointmentType, timeSlot, store]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], __assign({}, rest, { onClick: onClick }));
};

var ConfirmationSummary = function (_a) {
    var className = _a.className, type = _a.type, userLocation = _a.userLocation, store = _a.store, timeSlot = _a.timeSlot, rest = __rest(_a, ["className", "type", "userLocation", "store", "timeSlot"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('confirmation-summary', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentSummaryContainer, { className: "confirmation-summary__appointment" }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "confirmation-summary__buttons" },
            type && store && timeSlot && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ICSButton, { caption: intl.getLabel('appointments.confirmation.addToCalendar'), appointmentType: type, timeSlot: timeSlot, store: store })),
            store && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DirectionsButton, { caption: intl.getLabel('appointments.confirmation.getDirections'), userLocation: userLocation, store: store, variant: "outline" })))));
};

var ConfirmationSummaryContainer = function (_a) {
    var rest = __rest(_a, []);
    var appState = useAppointmentBookerContext().state;
    var mapState = useMapContext().state;
    var selectedAppointmentType = appState.selectedAppointmentType, selectedStore = appState.selectedStore, selectedTimeSlot = appState.selectedTimeSlot;
    var userLocation = mapState.userLocation;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ConfirmationSummary, __assign({}, rest, { type: selectedAppointmentType, userLocation: userLocation && { lat: userLocation.lat, lng: userLocation.lng }, store: selectedStore, timeSlot: selectedTimeSlot })));
};

var Confirmation = function (_a) {
    var _b, _c, _d, _e;
    var className = _a.className, personalDetails = _a.personalDetails, billingAddress = _a.billingAddress, selectedAppointmentType = _a.selectedAppointmentType, onNextStep = _a.onNextStep, isFullScreen = _a.isFullScreen, affiliateId = _a.affiliateId, externalBookingId = _a.externalBookingId, buttonLabel = _a.buttonLabel, rest = __rest(_a, ["className", "personalDetails", "billingAddress", "selectedAppointmentType", "onNextStep", "isFullScreen", "affiliateId", "externalBookingId", "buttonLabel"]);
    var _f = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])(), getLabel = _f.getLabel, getFormattedLabel = _f.getFormattedLabel;
    var firstName = ((_b = personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName) === null || _b === void 0 ? void 0 : _b.value) || ((_c = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.firstName) === null || _c === void 0 ? void 0 : _c.value);
    var email = ((_d = personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.email) === null || _d === void 0 ? void 0 : _d.value) || ((_e = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email) === null || _e === void 0 ? void 0 : _e.value);
    var getConfirmationLabel = function (label) {
        return getLabel("appointments.confirmation." + (!externalBookingId ? 'callback.' : '') + label);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('confirmation', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h2", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('confirmation__heading', isFullScreen ? 'h3' : 'h4') },
            getConfirmationLabel('heading.first'),
            " ", (firstName || '') + ", ",
            getConfirmationLabel('heading.last')),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "confirmation__text" },
            getConfirmationLabel('text.first'),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("b", null, " " + (email || '')),
            "."),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "confirmation__text" }, getConfirmationLabel('introduction')),
        affiliateId && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "confirmation__text" }, getFormattedLabel("appointments.affiliates." + affiliateId, {
            parseLink: true,
            hideLabelKey: true,
        }))),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "confirmation__text" }, getConfirmationLabel('text.last')),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ConfirmationSummaryContainer, null),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "confirmation__footer" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "confirmation__next-button", caption: buttonLabel || getLabel('appointments.confirmation.redirectButton'), onClick: onNextStep, variant: "outline" }))));
};

var ConfirmationContainer = function (props) {
    var isFullScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() !== _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var state = useAppointmentBookerContext().state;
    var customerDetails = state.customerDetails, externalBookingId = state.externalBookingId, queryParams = state.queryParams, selectedAppointmentType = state.selectedAppointmentType;
    var personalDetails = customerDetails.personalDetails, billingAddress = customerDetails.billingAddress;
    var _a = queryParams || {}, returnPath = _a.returnPath, returnLabel = _a.returnLabel;
    var affiliateId = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        var id = (queryParams || {})["affiliate-id"];
        return /^[a-zA-Z0-9-_]+$/.test(id) ? id : '';
    }, [queryParams]);
    var onNextStep = function () {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('appointment');
        }
        location.href = !!returnPath
            ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('returnPath', returnPath)
            : _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('location.origin', location.origin);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Confirmation, __assign({}, props, { personalDetails: personalDetails, billingAddress: billingAddress, onNextStep: onNextStep, selectedAppointmentType: selectedAppointmentType, isFullScreen: isFullScreen, affiliateId: affiliateId ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('affiliateId', affiliateId, '') : undefined, externalBookingId: externalBookingId, buttonLabel: returnLabel ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('returnLabel', returnLabel, '') : undefined })));
};

var getLinkedNodes = function (properties) {
    var e_1, _a, e_2, _b, e_3, _c;
    var nodes = properties.map(function (property) { return ({
        name: property.name,
        property: property,
        children: [],
    }); });
    try {
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var child = nodes_1_1.value;
            try {
                for (var _d = (e_2 = void 0, __values(child.property.parents)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var parentName = _e.value;
                    try {
                        for (var nodes_2 = (e_3 = void 0, __values(nodes)), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
                            var parent_1 = nodes_2_1.value;
                            if (parent_1.name === parentName) {
                                parent_1.children.push(child);
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (nodes_2_1 && !nodes_2_1.done && (_c = nodes_2.return)) _c.call(nodes_2);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return nodes;
};
var getRoots = function (linkedNodes) {
    return linkedNodes.filter(function (node) { return !node.property.parents.length; });
};
var generatePropertyTreeFromMatrix = function (_a) {
    var properties = _a.properties;
    return properties.length ? getRoots(getLinkedNodes(properties)) : [];
};
var isValueValid = function (property, value) {
    return property.options.some(function (option) { return option.value === value; });
};
var isPropertyValid = function (property, filter) {
    return property.name in filter
        ? isValueValid(property, filter[property.name])
        : isOptional(property, filter);
};
var isPropertyGroupValid = function (properties, filter) {
    return properties.every(function (property) { return isOptional(property, filter) || isValueValid(property, filter[property.name]); });
};
var isOptional = function (property, filter) { return !isRequired(property, filter); };
var isRequired = function (property, filter) {
    return !property.optional &&
        (property.requiredWhen.length === 0 ||
            property.requiredWhen.some(function (dependency) {
                return Object.entries(dependency).every(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], oneOfValue = _b[1];
                    return Array.isArray(oneOfValue) && oneOfValue.includes(filter[key]);
                });
            }));
};
var isFilterValid = function (_a, filter) {
    var properties = _a.properties;
    var groupedProperties = properties.reduce(function (acc, property) {
        var record = acc[property.name];
        if (!record) {
            acc[property.name] = property;
        }
        else {
            acc[property.name] = __spread((Array.isArray(record) ? record : [record]), [property]);
        }
        return acc;
    }, {});
    return Object.values(groupedProperties).every(function (property) {
        return Array.isArray(property)
            ? isPropertyGroupValid(property, filter)
            : isPropertyValid(property, filter);
    });
};
var getLocalizedLabel = function (label, locale) { return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* getLocalizedValue */ "q"])(label, locale) || Object.values(label).shift() || ''; };

var AppointmentTypeContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({ loading: true });
var normalizeTypeFilter = function (typeFilter) {
    return typeFilter
        ? Object.entries(typeFilter).reduce(function (acc, _a) {
            var _b = __read(_a, 2), name = _b[0], value = _b[1];
            acc[name] = value === null ? '' : value.toString();
            return acc;
        }, {})
        : {};
};
var AppointmentTypeProvider = function (_a) {
    var apiUrl = _a.apiUrl, children = _a.children;
    var _b = useAppointmentBookerContext(), state = _b.state, dispatch = _b.dispatch;
    var typeFilter = state.typeFilter, selectedAppointmentType = state.selectedAppointmentType;
    var typeMatrixResult = Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].typesMatrix, null, apiUrl);
    var _c = __read(typeMatrixResult, 3), loadingTypeMatrix = _c[0], typeMatrix = _c[1], typeMatrixError = _c[2];
    var isValidTypeSelection = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return (typeMatrix && typeFilter ? isFilterValid(typeMatrix, typeFilter) : false); }, [typeMatrix, typeFilter]);
    var typesOptions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({ skip: !isValidTypeSelection }); }, [
        isValidTypeSelection,
    ]);
    var typesQuery = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return normalizeTypeFilter(typeFilter); }, [typeFilter]);
    var typesResult = Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].types, typesOptions, apiUrl, typesQuery);
    var _d = __read(typesResult, 3), loadingTypes = _d[0], typesData = _d[1], typesError = _d[2];
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!loadingTypes) {
            if (typesData && typesData.length > 1) {
                console.error("Got " + typesData.length + " appointment types for filter " + JSON.stringify(typeFilter));
            }
            var type = typesData && typesData.length ? typesData[0] : null;
            if (type && (!selectedAppointmentType || type.id !== selectedAppointmentType.id)) {
                dispatch({
                    type: 'RESET_SELECTED_TIME_SLOT',
                });
                dispatch({
                    type: 'SET_SELECTED_APPOINTMENT_TYPE',
                    payload: type,
                });
            }
            else if (!type) {
                dispatch({
                    type: 'RESET_SELECTED_APPOINTMENT_TYPE',
                });
            }
        }
    }, typesResult);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentTypeContext.Provider, { value: { typeMatrix: typeMatrix, loading: loadingTypeMatrix, error: typeMatrixError }, children: children }));
};
var useAppointmentTypeContext = function () { return react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(AppointmentTypeContext); };
var AppointmentTypeConsumer = AppointmentTypeContext.Consumer;

var AppointmentTypeTree = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('appointment-type-tree', className) }), children));
};

var IsAdultProperty = function (_a) {
    var options = _a.options, scope = _a.scope, selected = _a.selected, onSelect = _a.onSelect, _b = _a.alignment, alignment = _b === void 0 ? 'horizontal' : _b, className = _a.className, rest = __rest(_a, ["options", "scope", "selected", "onSelect", "alignment", "className"]);
    var isActiveControl = selected && selected.value.toString();
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* RadioButtons */ "w"], __assign({}, rest, { items: options, scope: scope, initialValue: isActiveControl || '', onChange: onSelect, alignment: alignment, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('is-adult-property', className) })));
};

var getRadioOptions = function (adultTypes, locale) {
    return adultTypes.map(function (adultType) { return ({
        value: Boolean(adultType.value).toString(),
        label: getLocalizedLabel(adultType.label, locale),
    }); });
};
var IsAdultPropertyContainer = function (_a) {
    var node = _a.node;
    var _b = useAppointmentBookerContext(), state = _b.state, dispatch = _b.dispatch;
    var typeFilter = state.typeFilter;
    var property = node.property;
    var options = property.options, name = property.name;
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().locale;
    var onSelect = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (formControlState) {
        var name = formControlState.name, value = formControlState.value;
        dispatch({
            type: 'setTypePropertyValue',
            payload: { key: name, value: value === 'true' },
        });
    }, []);
    var getSelected = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (typeFilter) {
        var currentEntry = Object.entries(typeFilter)[Object.keys(typeFilter).indexOf(name)];
        if (currentEntry) {
            var label_1 = currentEntry[0];
            var value_1 = currentEntry[1];
            return {
                label: label_1,
                value: value_1,
            };
        }
        var defaultOption = options.find(function (option) { return option.default === true; });
        var label = defaultOption.label, value = defaultOption.value;
        return ({
            label: getLocalizedLabel(label, locale),
            value: value,
        } || undefined);
    }, []);
    var selected = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return getSelected(typeFilter); }, [typeFilter]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(IsAdultProperty, { options: getRadioOptions(options, locale), selected: selected, onSelect: onSelect, scope: name }));
};

var getRadioOptions$1 = function (appointmentTypes) {
    return appointmentTypes.map(function (type) { return ({
        value: type.id,
        label: type.name,
    }); });
};
var AppointmentType = function (_a) {
    var className = _a.className, baseType = _a.baseType, subTypes = _a.subTypes, tooltipKey = _a.tooltipKey, selectedSubType = _a.selectedSubType, onSelectSubType = _a.onSelectSubType, _b = _a.alignment, alignment = _b === void 0 ? 'vertical' : _b, rest = __rest(_a, ["className", "baseType", "subTypes", "tooltipKey", "selectedSubType", "onSelectSubType", "alignment"]);
    var getFormattedLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().getFormattedLabel;
    var tooltipMessage = tooltipKey ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, getFormattedLabel(tooltipKey, {
        parseLink: true,
        openLinksInNewTab: true,
    }))) : null;
    // Ugly hack to enforce re-rendering RadioButtons when the subtype selection takes place in another form control.
    var isActiveControl = subTypes.includes(selectedSubType || null);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('appointment-type', className) }),
        baseType && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { className: "appointment-type__label" },
            baseType,
            tooltipMessage && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tooltip */ "sb"], { className: "appointment-type__tooltip", id: baseType, message: tooltipMessage, parseHtml: true })))),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "appointment-type__items" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* RadioButtons */ "w"], { key: baseType + "-" + (isActiveControl ? 'active' : 'inactive'), items: getRadioOptions$1(subTypes), scope: baseType, onChange: onSelectSubType, initialValue: isActiveControl && selectedSubType ? selectedSubType.id : '', alignment: alignment }))));
};

var TypeProperty = function (_a) {
    var className = _a.className, propsList = _a.propsList, selectedSubType = _a.selectedSubType;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('type-property', className) }, propsList.map(function (props, index) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentType, __assign({}, props, { key: index, selectedSubType: selectedSubType }))); })));
};

/*
 * Generates a simplified version of the parent->child relation tree,
 * so that we can more easily produce form controls from the tree data
 * and resolve value changes and state, back to the relation tree.
 */
var getTypeGroups = function (locale, property, children) {
    return property.options.map(function (_a) {
        var label = _a.label, value = _a.value, tooltipKey = _a.tooltipKey;
        var childProp = children.find(function (_a) {
            var childProperty = _a.property;
            return childProperty.requiredWhen.some(function (requirement) {
                var reqPropertyValue = typeof requirement !== 'undefined' ? requirement[property.name] : null;
                return Array.isArray(reqPropertyValue) ? reqPropertyValue.includes(value) : false;
            });
        });
        var subTypes = (typeof childProp !== 'undefined' ? childProp.property.options : []).map(function (_a) {
            var label = _a.label, value = _a.value, isDefault = _a.default;
            return ({
                name: childProp.property.name,
                label: getLocalizedLabel(label, locale),
                value: value,
                isDefault: !!isDefault,
            });
        });
        return {
            name: property.name,
            label: getLocalizedLabel(label, locale),
            value: value,
            tooltipKey: tooltipKey,
            subTypes: subTypes,
        };
    });
};
var propListFromTypeGroups = function (typeGroups, typeFilter, onChangeSubType) {
    return typeGroups.map(function (group) { return ({
        baseType: group.label,
        subTypes: group.subTypes.map(function (_a) {
            var name = _a.name, value = _a.value, label = _a.label, isDefault = _a.isDefault;
            var isSelected = typeFilter[group.name] === group.value && typeFilter[name] === value;
            return {
                id: value,
                name: label,
                isDefault: isDefault,
                isSelected: isSelected,
            };
        }),
        tooltipKey: group.tooltipKey,
        onSelectSubType: function (formControlState) {
            return onChangeSubType(group, formControlState);
        },
    }); });
};
var getSelectedSubType = function (propsList) {
    var subTypes = propsList.reduce(function (acc, props) { return __spread(acc, props.subTypes); }, []);
    return (subTypes.find(function (subType) { return !!subType.isSelected; }) ||
        subTypes.find(function (subType) { return !!subType.isDefault; }) ||
        subTypes[0]);
};
var TypePropertyContainer = function (_a) {
    var node = _a.node;
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().locale;
    var _b = useAppointmentBookerContext(), state = _b.state, dispatch = _b.dispatch;
    var typeFilter = state.typeFilter;
    var children = node.children, property = node.property;
    var typeGroups = getTypeGroups(locale, property, children);
    var onChangeSubType = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (typeGroup, formControlState) {
        var value = formControlState.value;
        var subType = typeGroup.subTypes.find(function (subType) { return subType.value === value; });
        if (subType) {
            dispatch({
                type: 'setTypePropertyValue',
                payload: { key: typeGroup.name, value: typeGroup.value },
            });
            dispatch({
                type: 'setTypePropertyValue',
                payload: { key: subType.name, value: subType.value },
            });
        }
    }, []);
    var propsList = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return propListFromTypeGroups(typeGroups, typeFilter, onChangeSubType); }, [typeGroups, typeFilter, onChangeSubType]);
    var selectedSubType = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return getSelectedSubType(propsList); }, [propsList]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TypeProperty, { propsList: propsList, selectedSubType: selectedSubType });
};

var isGroupedSelect = function (node) {
    var hasMultipleChildren = node.children.length > 1;
    var uniqueChildNames = node.children.reduce(function (acc, child) { return (!acc.includes(child.name) ? __spread(acc, [child.name]) : acc); }, []);
    var childrenHaveIdenticalNames = uniqueChildNames.length === 1;
    var childRequirementsCanBeMet = hasMultipleChildren &&
        node.property.options.every(function (parentOption) {
            var requiredChildren = node.children.filter(function (child) {
                return child.property.requiredWhen.some(function (dependency) {
                    var conditions = dependency[node.property.name];
                    return !!conditions && conditions.includes(parentOption.value);
                });
            });
            if (!requiredChildren.length) {
                console.error('Parent value without matching subtype not yet supported!');
                return false;
            }
            if (requiredChildren.length > 1) {
                console.error('Multiple nested properties not yet supported!');
                return false;
            }
            return true;
        });
    return hasMultipleChildren && childrenHaveIdenticalNames && childRequirementsCanBeMet;
};
var isLabeledSwitch = function (node) {
    var hasNoChildren = node.children.length === 0;
    var hasTwoOptions = node.property.options.length === 2;
    var hasLabeledOptions = node.property.options.every(function (option) {
        return Object.values(option.label).some(function (translation) { return !!translation; });
    });
    return hasNoChildren && hasTwoOptions && hasLabeledOptions;
};
var AppointmentTypeTreeContainer = function (_a) {
    var typeMatrix = _a.typeMatrix, rest = __rest(_a, ["typeMatrix"]);
    var tree = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return generatePropertyTreeFromMatrix(typeMatrix); }, [typeMatrix]);
    var controls = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        return tree.map(function (node) {
            if (isGroupedSelect(node)) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TypePropertyContainer, { key: node.name, node: node, tree: tree });
            }
            if (isLabeledSwitch(node)) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(IsAdultPropertyContainer, { key: node.name, node: node });
            }
            console.error("Unsupported property " + node.name);
            return null;
        });
    }, [tree]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentTypeTree, __assign({}, rest), controls);
};

var getDayKeyByNumber = function (day) {
    return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][day];
};
var isClick = function (prevPos, clickPos) {
    return Math.abs(prevPos.x - clickPos.x) <= 10 && Math.abs(prevPos.y - clickPos.y) <= 10;
};
var mousePosFromEvent = function (ev) { return ({
    x: ev.nativeEvent.x,
    y: ev.nativeEvent.y,
}); };
var DateGroupItem = function (_a) {
    var className = _a.className, selected = _a.selected, date = _a.date, onSelect = _a.onSelect, slots = _a.slots, _b = _a.checkRangeTimeSlots, checkRangeTimeSlots = _b === void 0 ? false : _b, rest = __rest(_a, ["className", "selected", "date", "onSelect", "slots", "checkRangeTimeSlots"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var label = intl.getLabel("appointments.shortDays." + getDayKeyByNumber(date.getDay()));
    // Keep track of mouse position to prevent clicks on swiping
    var mousePos = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])({ x: 0, y: 0 });
    var handleMouseDown = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (ev) {
        mousePos.current = mousePosFromEvent(ev);
    }, []);
    var handleMouseUp = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (ev) {
        if (isClick(mousePos.current, mousePosFromEvent(ev))) {
            onSelect(date);
        }
    }, [date]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { key: date.toUTCString(), className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('date-group-item', { 'date-group-item--selected': selected }, { 'date-group-item--no-slots': checkRangeTimeSlots && slots && !slots.length }, className), role: "button", onMouseDown: handleMouseDown, onMouseUp: handleMouseUp }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "date-group-item__day" }, label),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "date-group-item__date" }, date.getDate())));
};

var DateGroup = function (_a) {
    var className = _a.className, selected = _a.selected, dates = _a.dates, slots = _a.slots, _b = _a.checkRangeTimeSlots, checkRangeTimeSlots = _b === void 0 ? false : _b, onSelectDate = _a.onSelectDate, rest = __rest(_a, ["className", "selected", "dates", "slots", "checkRangeTimeSlots", "onSelectDate"]);
    var items = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        return dates.map(function (date, index) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DateGroupItem, { key: date.toUTCString(), date: date, slots: slots ? slots[index] || [] : slots, checkRangeTimeSlots: checkRangeTimeSlots, selected: isSameDay(date, selected), onSelect: onSelectDate })); });
    }, [dates, selected, onSelectDate, slots]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('date-group', className) }), items));
};

var VirtualizeSwipeableViews = Object(react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22__["bindKeyboard"])(Object(react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22__["virtualize"])(react_swipeable_views__WEBPACK_IMPORTED_MODULE_21___default.a));
var useRangeContext = function (initialRange) {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var months = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(initialRange), 2), range = _a[0], setRange = _a[1];
    var context = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return intl.getLabel("appointments.months." + months[range[0].getMonth()]) + " " + range[0].getFullYear();
    }, [intl, months, range]);
    return { context: context, range: range, setRange: setRange };
};
var useDateListerState = function (rangeProvider) {
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(0), 2), index = _a[0], setIndex = _a[1];
    var range = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return rangeProvider(index); }, [index]);
    var onPreviousMonth = function () { return setIndex(Math.max(0, index - 4)); };
    var onNextMonth = function () { return setIndex(index + 4); };
    var onPreviousWeek = function () { return setIndex(Math.max(0, index - 1)); };
    var onNextWeek = function () { return setIndex(index + 1); };
    return { index: index, setIndex: setIndex, range: range, onPreviousMonth: onPreviousMonth, onNextMonth: onNextMonth, onPreviousWeek: onPreviousWeek, onNextWeek: onNextWeek };
};
var week = 1000 * 60 * 60 * 24 * 7;
var DateLister = function (_a) {
    var className = _a.className, selected = _a.selected, rangeTimeSlots = _a.rangeTimeSlots, _b = _a.checkRangeTimeSlots, checkRangeTimeSlots = _b === void 0 ? false : _b, rangeProvider = _a.rangeProvider, onSelectDate = _a.onSelectDate, onRangeChange = _a.onRangeChange, rest = __rest(_a, ["className", "selected", "rangeTimeSlots", "checkRangeTimeSlots", "rangeProvider", "onSelectDate", "onRangeChange"]);
    var selectedDate = useAppointmentBookerContext().state.selectedDate;
    var dateListerState = useDateListerState(rangeProvider);
    var index = dateListerState.index, setIndex = dateListerState.setIndex, range = dateListerState.range;
    var rangeContext = useRangeContext(range);
    var onChangeIndex = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (newIndex) { return (newIndex !== index ? setIndex(newIndex) : undefined); }, [index]);
    var activeDate = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return selectedDate || selected; }, [selectedDate, selected]);
    var slideRenderer = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (_a) {
        var index = _a.index, key = _a.key;
        return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DateGroup, { key: key, selected: activeDate, dates: rangeProvider(index), slots: rangeTimeSlots, checkRangeTimeSlots: checkRangeTimeSlots, onSelectDate: onSelectDate }));
    }, [activeDate, rangeProvider, rangeTimeSlots, onSelectDate]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        rangeContext.setRange(range);
        onRangeChange(range);
    }, [range]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!isWithinTimeSpan(activeDate, range[0], range[6])) {
            var indexDelta_1 = Math.floor((activeDate.getTime() - range[0].getTime()) / week);
            setIndex(function (oldIndex) { return oldIndex + indexDelta_1; });
        }
    }, [activeDate]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('date-lister', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "date-lister__month" },
            rangeContext.context,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "date-lister__month-arrows" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('date-lister__arrow', 'date-lister__month-arrow', 'date-lister__month-arrow--previous', {
                        'date-lister__arrow--disabled': index === 0,
                    }), role: "button", onClick: dateListerState.onPreviousMonth },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "chevron-left" })),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "date-lister__arrow date-lister__month-arrow date-lister__month-arrow--next", role: "button", onClick: dateListerState.onNextMonth },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "chevron-right" })))),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "date-lister__week" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(VirtualizeSwipeableViews, { style: { height: '100%' }, index: index, enableMouseEvents: true, slideRenderer: slideRenderer, onChangeIndex: onChangeIndex }),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('date-lister__arrow', 'date-lister__week-arrow', 'date-lister__week-arrow--previous', {
                    'date-lister__arrow--disabled': index === 0,
                }), role: "button", onClick: dateListerState.onPreviousWeek },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "chevron-left" })),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "date-lister__arrow date-lister__week-arrow date-lister__week-arrow--next", role: "button", onClick: dateListerState.onNextWeek },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "chevron-right" })))));
};

var StoreListItem = function (_a) {
    var className = _a.className, store = _a.store, onSelectStore = _a.onSelectStore, children = _a.children, rest = __rest(_a, ["className", "store", "onSelectStore", "children"]);
    var onClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () { return onSelectStore(store); }, [store, onSelectStore]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-list-item', className), onClick: onClick }),
        children,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { className: "store-list-item__chevron", name: "chevron-right" })));
};

var StoreSelectionList = function (_a) {
    var className = _a.className, onSelectStore = _a.onSelectStore, selectedStore = _a.selectedStore, stores = _a.stores, _b = _a.showAvailability, showAvailability = _b === void 0 ? false : _b, _c = _a.showAvailabilityCount, showAvailabilityCount = _c === void 0 ? false : _c, _d = _a.checkAvailability, checkAvailability = _d === void 0 ? false : _d, rest = __rest(_a, ["className", "onSelectStore", "selectedStore", "stores", "showAvailability", "showAvailabilityCount", "checkAvailability"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-selection-list', className) }), stores.map(function (store) {
        var availability = checkAvailability ? getAvailability(store) : 0;
        return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreListItem, { key: store.code, store: store, onSelectStore: onSelectStore, disabled: checkAvailability && !availability },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSummary, { className: "store-list-item__summary", store: store, availability: availability, showAvailability: showAvailability, showAvailabilityCount: showAvailabilityCount })));
    })));
};

var EditPanel = function (_a) {
    var loadingMatrix = _a.loadingMatrix, loadingStores = _a.loadingStores, loadingSlots = _a.loadingSlots, date = _a.date, store = _a.store, stores = _a.stores, rangeProvider = _a.rangeProvider, onSelectDate = _a.onSelectDate, onRangeChange = _a.onRangeChange, onSelectStore = _a.onSelectStore, onShowMoreStores = _a.onShowMoreStores, hideShowMoreStores = _a.hideShowMoreStores, onConfirm = _a.onConfirm, onClose = _a.onClose, typeMatrix = _a.typeMatrix, _b = _a.disabledConfirmButton, disabledConfirmButton = _b === void 0 ? false : _b;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().getLabel;
    var withDateLister = Boolean(date);
    var withTypeSelection = !withDateLister;
    var withStoreLister = Boolean(!disabledConfirmButton && store);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { className: "edit-panel", isOpen: true, showIcon: true, title: getLabel('appointments.editPanel.title'), onModalClose: onClose, useScrollLock: false },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
                'edit-panel__content': true,
                'edit-panel__content--with-date-lister': withDateLister,
            }) },
            withTypeSelection &&
                (loadingMatrix ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "edit-panel__loader" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentTypeTreeContainer, { typeMatrix: typeMatrix }))),
            withDateLister && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DateLister, { selected: date, rangeProvider: rangeProvider, onSelectDate: onSelectDate, onRangeChange: onRangeChange })),
            withStoreLister && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, loadingStores ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "edit-panel__loader" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                !withDateLister && stores.length > 0 && !store && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "edit-panel__store-title" }, getLabel('appointments.editPanel.storeTitle'))),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                    store && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "edit-panel__store-title" }, getLabel('appointments.editPanel.yourStore')),
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "store-selection-list" },
                            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreListItem, { key: store.code, store: store, onSelectStore: onSelectStore, disabled: withDateLister && getAvailability(store) > 0 ? false : true },
                                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSummary, { className: "store-list-item__summary", store: store, showAvailability: withDateLister, showAvailabilityCount: withDateLister }))))),
                    stores && stores.length > 0 && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "edit-panel__store-title" }, getLabel('appointments.editPanel.selectStore')),
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelectionList, { stores: store
                                ? stores.filter(function (filteredStore) { return filteredStore.code !== store.code; })
                                : stores, onSelectStore: onSelectStore, checkAvailability: withDateLister, showAvailability: withDateLister, showAvailabilityCount: withDateLister })))),
                loadingSlots ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "edit-panel__loader" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                    withDateLister && stores.length > 0 && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelectionList, { className: hideShowMoreStores ? 'store-selection-list--completed' : undefined, stores: stores, onSelectStore: onSelectStore, checkAvailability: withDateLister, showAvailability: withDateLister, showAvailabilityCount: withDateLister }))),
                    !hideShowMoreStores && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "edit-panel__show-more", variant: "ghost", onClick: onShowMoreStores, caption: getLabel('appointments.storeSelection.showMore') }))))))))),
        !withStoreLister && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "edit-panel__controls" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "edit-panel__button", caption: getLabel('appointments.editPanel.confirm'), onClick: onConfirm, disabled: disabledConfirmButton })))));
};

var EditPanelContainer = function (props) {
    var _a = useAppointmentBookerContext(), _b = _a.state, openEditPanel = _b.openEditPanel, selectedAppointmentType = _b.selectedAppointmentType, selectedDate = _b.selectedDate, selectedStore = _b.selectedStore, timeFilter = _b.timeFilter, typeFilter = _b.typeFilter, dispatchAppAction = _a.dispatch;
    var _c = useAppointmentTypeContext(), loadingMatrix = _c.loading, typeMatrix = _c.typeMatrix;
    var today = react__WEBPACK_IMPORTED_MODULE_0___default.a.useRef(new Date());
    var dateRangeProvider = useDateRangeProvider(today.current);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var onRangeChange = function () { };
    var onSelectDate = function (date) {
        return dispatchAppAction({
            type: 'SET_SELECTED_DATE',
            payload: date,
        });
    };
    var storedAppointmentType = react__WEBPACK_IMPORTED_MODULE_0___default.a.useRef(selectedAppointmentType);
    var storedTypeFilter = react__WEBPACK_IMPORTED_MODULE_0___default.a.useRef(typeFilter);
    var hasAppointmentType = Boolean(selectedAppointmentType);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (openEditPanel) {
            storedAppointmentType.current = selectedAppointmentType;
            storedTypeFilter.current = typeFilter;
        }
    }, [openEditPanel]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!hasAppointmentType) {
            _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].warning('appointments.editPanel.unavailableAppointmentType');
        }
    }, [hasAppointmentType]);
    /*
     * TODO: Temporary solution: Replace once GANS supports returning stores with availability for a specific day
     * (yes, the variable name is annoyingly long and non-conforming on purpose)
     */
    var temp__filterStoresByDateSpecificAvailability = Boolean(selectedDate);
    var storedTimeFilter = react__WEBPACK_IMPORTED_MODULE_0___default.a.useRef(timeFilter);
    // TODO: Temporary solution: Replace once GANS supports returning stores with availability for a specific day
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (temp__filterStoresByDateSpecificAvailability) {
            dispatchAppAction({
                type: 'SET_TIME_FILTER',
                payload: {
                    date: { type: 'single', value: selectedDate },
                    time: { type: 'any' },
                },
            });
        }
    }, [selectedDate, temp__filterStoresByDateSpecificAvailability]);
    var _d = useStoresContext(), _e = _d.state, loadingStores = _e.loadingStores, loadingSlots = _e.loadingSlots, filteredStores = _e.filtered, storeList = _e.list, dispatchStoresAction = _d.dispatch;
    // TODO: Temporary solution: Replace once GANS supports returning stores with availability for a specific day
    var stores = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        if (!hasAppointmentType) {
            return [];
        }
        var stores = temp__filterStoresByDateSpecificAvailability
            ? filteredStores.filter(function (store) { return store.slots && store.slots !== 'loading' && store.slots.length; })
            : filteredStores;
        return stores;
    }, [filteredStores, temp__filterStoresByDateSpecificAvailability, hasAppointmentType]);
    /*
     * TODO: Temporary solution: Remove "temp__filterStoresByDateSpecificAvailability" clause once GANS
     * supports returning stores with availability for a specific day
     */
    var hideShowMoreStores = temp__filterStoresByDateSpecificAvailability || filteredStores.length === storeList.length;
    var onShowMoreStores = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return dispatchStoresAction({ type: 'LOAD_MORE' }); }, []);
    var handleConfirm = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        // TODO: Temporary solution: Replace once GANS supports returning stores with availability for a specific day
        if (temp__filterStoresByDateSpecificAvailability) {
            dispatchAppAction({ type: 'RESET_SELECTED_DATE' });
            dispatchAppAction({ type: 'SET_TIME_FILTER', payload: storedTimeFilter.current });
        }
        if (!selectedAppointmentType) {
            dispatchAppAction({ type: 'SET_TYPE_FILTER', payload: storedTypeFilter.current });
            dispatchAppAction({
                type: 'SET_SELECTED_APPOINTMENT_TYPE',
                payload: storedAppointmentType.current,
            });
        }
        dispatchAppAction({ type: 'SET_EDIT_PANEL_OPEN', payload: false });
    }, [selectedAppointmentType]);
    var handleSelectStore = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (store) {
        // TODO: Temporary solution: Replace once GANS supports returning stores with availability for a specific day
        if (temp__filterStoresByDateSpecificAvailability) {
            dispatchAppAction({ type: 'SET_TIME_FILTER', payload: storedTimeFilter.current });
        }
        dispatchAppAction({ type: 'RESET_SELECTED_TIME_SLOT' });
        dispatchAppAction({ type: 'SET_SELECTED_STORE', payload: store });
        dispatchAppAction({ type: 'SET_EDIT_PANEL_OPEN', payload: false });
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(EditPanel, __assign({}, props, { loadingMatrix: loadingMatrix, loadingStores: loadingStores, loadingSlots: loadingSlots, typeMatrix: typeMatrix || { properties: [] }, date: selectedDate, rangeProvider: dateRangeProvider, onRangeChange: onRangeChange, onSelectDate: onSelectDate, store: selectedStore, stores: stores, onShowMoreStores: onShowMoreStores, hideShowMoreStores: hideShowMoreStores, onSelectStore: handleSelectStore, disabledConfirmButton: !selectedAppointmentType, onConfirm: handleConfirm, onClose: handleConfirm })));
};

var RescheduleAlert = function (_a) {
    var timeSlot = _a.timeSlot;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().getLabel;
    var from = timeSlot.from, until = timeSlot.until;
    var date = dateToDayNumberMonthYearString(from);
    var time = datesToLocalTimeSpan(from, until);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "info", className: "appointment-booker__reschedule-alert", title: getLabel('appointments.rescheduling.alert.title'), message: date + " | " + time }));
};

/**
 * Takes a ComposedFormValueState and filters out all `readonly` fields.
 *
 * Warning: this function may give you headaches and/or nightmares.
 */
var filterReadonlyState = function (state) {
    return Object.entries(state).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), partKey = _c[0], partState = _c[1];
        return (__assign(__assign({}, result), (_b = {}, _b[partKey] = Object.entries(partState).reduce(function (filteredPart, _a) {
            var _b;
            var _c = __read(_a, 2), fieldKey = _c[0], fieldState = _c[1];
            if (fieldState && fieldState.readonly) {
                return filteredPart;
            }
            return __assign(__assign({}, filteredPart), (_b = {}, _b[fieldKey] = fieldState, _b));
        }, {}), _b)));
    }, {});
};

var userDataToFormState = function (data) {
    var result = _grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* Util */ "D"].fieldsToFormState(data);
    Object.values(result).forEach(function (state) {
        if (state && state.value) {
            state.readonly = true;
        }
    });
    return result;
};

var defaultReducerState = {
    consents: { createAccount: false },
    optIns: {
        offersByPost: false,
        offersByMail: false,
    },
    setConsent: function (key, value) {
        return console.warn("Missing Checks context provider. Called setConsent with: " + String(key) + "=" + value);
    },
    setOptIn: function (key, value) {
        return console.warn("Missing Checks context provider. Called setOptIn with: " + String(key) + "=" + value);
    },
};
var reducer$3 = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'SET_CONSENT':
            return __assign(__assign({}, state), { optIns: __assign({}, (action.payload.key === 'createAccount' ? defaultReducerState.optIns : state.optIns)), consents: __assign(__assign({}, state.consents), (_a = {}, _a[action.payload.key] = action.payload.value, _a)) });
        case 'SET_OPT_IN':
            return __assign(__assign({}, state), { optIns: __assign(__assign({}, state.optIns), (_b = {}, _b[action.payload.key] = action.payload.value, _b)) });
        default:
            throw new UnreachableCase(action);
    }
};
var Context = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext(defaultReducerState);
var Consumer = Context.Consumer, ProviderComponent = Context.Provider;
var useChecksState = function () {
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useReducer(reducer$3, defaultReducerState), 2), state = _a[0], dispatch = _a[1];
    var setConsent = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (key, value) {
        return dispatch({ type: 'SET_CONSENT', payload: { key: key, value: value } });
    }, []);
    var setOptIn = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (key, value) {
        return dispatch({ type: 'SET_OPT_IN', payload: { key: key, value: value } });
    }, []);
    return __assign(__assign({}, state), { setConsent: setConsent,
        setOptIn: setOptIn });
};
var Provider = function (_a) {
    var children = _a.children;
    var state = useChecksState();
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ProviderComponent, { value: state }, children);
};
var useChecksContext = function () { return react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(Context); };
var mapOptInsToRequest = function (availableOptIns, optIns) {
    return availableOptIns.reduce(function (result, _a) {
        var _b;
        var title = _a.title, value = _a.value;
        return (__assign(__assign({}, result), (_b = {}, _b[value] = {
            value: !!optIns[value],
            literalText: title,
            uiType: 'checkbox',
        }, _b)));
    }, {});
};

var Checks = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var _b = useAppointmentBookerContext(), consents = _b.consents, optIns = _b.optIns;
    var checksContext = useChecksContext();
    var onChangeConsent = function (value) { return function (state) {
        return checksContext.setConsent(value, state.value);
    }; };
    var onChangeOptIn = function (value) { return function (state) {
        return checksContext.setOptIn(value, state.value);
    }; };
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('checks', className) }),
        (consents || []).map(function (consent) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { key: consent.value, className: "checks__consent" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_24__[/* Checkbox */ "c"], { checked: checksContext.consents[consent.value], onChange: onChangeConsent(consent.value), value: !checksContext.consents[consent.value], disabled: false }),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "checks__consent-label" }, consent.title))); }),
        checksContext.consents.createAccount &&
            (optIns || []).map(function (optIn) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { key: optIn.value, className: "checks__optIn" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_24__[/* Checkbox */ "c"], { checked: checksContext.optIns[optIn.value], onChange: onChangeOptIn(optIn.value), value: !checksContext.optIns[optIn.value], disabled: false }),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "checks__optIn-label" }, optIn.title))); })));
};

var ContextualConfirmation = function (_a) {
    var buttonLabel = _a.buttonLabel, className = _a.className, children = _a.children, onConfirm = _a.onConfirm, subscript = _a.subscript, disabled = _a.disabled, rest = __rest(_a, ["buttonLabel", "className", "children", "onConfirm", "subscript", "disabled"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('contextual-confirmation', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "contextual-confirmation__children" }, children),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "contextual-confirmation__button", caption: buttonLabel, onClick: onConfirm, disabled: disabled }),
        subscript && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "contextual-confirmation__subscript" }, subscript)));
};

var StepDetailsOverview = function (_a) {
    var className = _a.className, isValid = _a.isValid, isLoading = _a.isLoading, _b = _a.hasCompleted, hasCompleted = _b === void 0 ? false : _b, onCustomerDetailsChange = _a.onCustomerDetailsChange, onCreateAppointment = _a.onCreateAppointment, notLoggedIn = _a.notLoggedIn, signInMyAccountUrl = _a.signInMyAccountUrl, initialFormState = _a.initialFormState, form = _a.form, rest = __rest(_a, ["className", "isValid", "isLoading", "hasCompleted", "onCustomerDetailsChange", "onCreateAppointment", "notLoggedIn", "signInMyAccountUrl", "initialFormState", "form"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        window.scrollTo(0, 0);
    }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('contact-details-overview', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h2", { className: "h4 contact-details-overview__heading" }, intl.getLabel('appointments.selectionSteps.details.appointmentHeading')),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentSummaryContainer, { className: "contact-details-overview__appointment" }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h3", { className: "h4 contact-details-overview__heading" }, intl.getLabel('appointments.selectionSteps.details.heading')),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "contact-details-overview__content" },
            notLoggedIn && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], null,
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", null,
                    intl.getLabel('appointments.selectionSteps.details.haveAnAccount'),
                    ' ',
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("a", { href: signInMyAccountUrl }, intl.getLabel('appointments.selectionSteps.details.signIn')),
                    ' ',
                    intl.getLabel('appointments.selectionSteps.details.addInfo')))),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* ComposedForm */ "d"], { name: "contactDetails", className: "contact-details-overview__form", initialFormState: initialFormState, onChange: onCustomerDetailsChange },
                form,
                notLoggedIn ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Checks, null) : null)),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ContextualConfirmation, { buttonLabel: intl.getLabel('appointments.selectionSteps.details.stepNext'), onConfirm: onCreateAppointment, subscript: intl.getLabel("appointments.selectionSteps.details." + (isValid ? 'subscriptFilled' : 'subscriptEmpty')), disabled: !isValid || isLoading || hasCompleted })));
};

var StepDetailsOverviewContainer = function (_a) {
    var apiUrl = _a.apiUrl, loadOptIns = _a.loadOptIns, fetchOptIns = _a.fetchOptIns, // to avoid spreading unused props from withUserData to native div
    fetchUserData = _a.fetchUserData, // to avoid spreading unused props from withUserData to native div
    recoverSession = _a.recoverSession, signInMyAccountUrl = _a.signInMyAccountUrl, rest = __rest(_a, ["apiUrl", "loadOptIns", "fetchOptIns", "fetchUserData", "recoverSession", "signInMyAccountUrl"]);
    var _b = useAppointmentBookerContext(), state = _b.state, dispatch = _b.dispatch, loadingUser = _b.loadingUser, availableConsents = _b.consents, availableOptIns = _b.optIns, userDataProps = _b.userData;
    var _c = useChecksContext(), consents = _c.consents, optIns = _c.optIns;
    var selectedStore = state.selectedStore, selectedAppointmentType = state.selectedAppointmentType, selectedTimeSlot = state.selectedTimeSlot, hasCompleted = state.hasCompleted, isRescheduling = state.isRescheduling, queryParams = state.queryParams;
    var userData = userDataProps.userData;
    var appointmentId = (queryParams || {}).appointmentId;
    var _d = __read(useRouteState(), 2), activeRoute = _d[0], setActiveRoute = _d[1];
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(false), 2), formValid = _e[0], setFormValid = _e[1];
    var _f = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(false), 2), isLoading = _f[0], setIsLoading = _f[1];
    var routing = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "R"])(_grandvision_auth__WEBPACK_IMPORTED_MODULE_8__[/* Selectors */ "j"].getAuth).routing;
    var _g = window.location, protocol = _g.protocol, host = _g.host;
    var notLoggedIn = !loadingUser && userData.status !== 'success';
    var affiliateId = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        var id = (queryParams || {})["affiliate-id"];
        return /^[a-zA-Z0-9-_]+$/.test(id) ? id : '';
    }, [queryParams]);
    var hasConsent = !notLoggedIn ||
        !availableConsents.length ||
        availableConsents.every(function (consent) { return consents[consent.value]; });
    var handleCustomerDetailsChange = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (newFormState) {
        setFormValid(newFormState.formValid);
        dispatch({ type: 'SET_CUSTOMER_DETAILS', payload: newFormState.formState });
    }, []);
    var customerDetails = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return _grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* Util */ "D"].getValuesFromComposedState(state.customerDetails); }, [state.customerDetails]);
    var optins = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return mapOptInsToRequest(availableOptIns, optIns); }, [
        availableOptIns,
        optIns,
    ]);
    var createAppointmentRequest = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({
        storeCode: selectedStore ? selectedStore.code : 0,
        appointmentTypeId: selectedAppointmentType ? selectedAppointmentType.id : '',
        startTime: selectedTimeSlot ? toLocalDateTime(selectedTimeSlot.from) : '',
        endTime: selectedTimeSlot ? toLocalDateTime(selectedTimeSlot.until) : '',
        personalDetails: customerDetails.personalDetails,
        billingAddress: customerDetails.billingAddress,
        affiliateId: _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('affiliateId', affiliateId, ''),
        optins: optins,
    }); }, [affiliateId, customerDetails, selectedStore, selectedAppointmentType, selectedTimeSlot, optins]);
    var createCustomerRequest = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({
        additionalAccountData: {
            personalDetails: {
                personalDetails: customerDetails.personalDetails,
                billingAddress: customerDetails.billingAddress,
            },
            optins: optins,
        },
        loginRedirectUrl: protocol + "//" + host + "/" + routing.basePath + "/callback",
        emailAddress: customerDetails.personalDetails.email,
    }); }, [customerDetails, protocol, host, routing.basePath, optins]);
    var getAuthToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!notLoggedIn) return [3 /*break*/, 1];
                    _a = '';
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, Object(_grandvision_auth__WEBPACK_IMPORTED_MODULE_8__[/* getToken */ "n"])()];
                case 2:
                    _a = (_b.sent()) || '';
                    _b.label = 3;
                case 3: return [2 /*return*/, _a];
                case 4:
                    error_1 = _b.sent();
                    console.error('Failed to getToken:', error_1);
                    return [2 /*return*/, ''];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var createCustomer = function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Customers */ "c"].create(apiUrl, request)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_2 = _a.sent();
                    console.error('Failed to create new customer:', error_2);
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var createAppointment = function (request, token) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].create(apiUrl, request, token || '')];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_3 = _a.sent();
                    console.error('Failed to create new appointment:', error_3);
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var cancelAppointment = function (appointmentId, token) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].cancel(apiUrl, appointmentId, token || '')];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_4 = _a.sent();
                    console.error("Failed to remove appointment with id " + appointmentId + ":", error_4);
                    throw error_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCreateAppointment = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, accDataToken, bookedAppointment, createCustomerResult, accountDataToken, createAppointmentresult, externalBookingId, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 10, 11, 12]);
                    return [4 /*yield*/, getAuthToken()];
                case 2:
                    token = _a.sent();
                    accDataToken = void 0;
                    if (!appointmentId) return [3 /*break*/, 4];
                    return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Appointments */ "a"].get(apiUrl, _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('appointmentId', appointmentId), token)];
                case 3:
                    bookedAppointment = _a.sent();
                    if (bookedAppointment.status === 'CANCEL') {
                        _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].failed('appointments.selectionSteps.detailsOverview.alreadyRescheduledError');
                        return [2 /*return*/];
                    }
                    _a.label = 4;
                case 4:
                    // Reset external booking id before doing a new create appointment request
                    dispatch({ type: 'RESET_EXTERNAL_BOOKING_ID' });
                    if (!!token) return [3 /*break*/, 6];
                    return [4 /*yield*/, createCustomer(createCustomerRequest)];
                case 5:
                    createCustomerResult = _a.sent();
                    accountDataToken = createCustomerResult.accountDataToken;
                    accDataToken = accountDataToken;
                    _a.label = 6;
                case 6: return [4 /*yield*/, createAppointment(__assign(__assign({}, createAppointmentRequest), { accountDataToken: accDataToken }), token)];
                case 7:
                    createAppointmentresult = _a.sent();
                    externalBookingId = ((createAppointmentresult === null || createAppointmentresult === void 0 ? void 0 : createAppointmentresult.additionalTags) || {}).externalBookingId;
                    if (externalBookingId) {
                        dispatch({ type: 'SET_EXTERNAL_BOOKING_ID', payload: externalBookingId });
                    }
                    if (!(isRescheduling && appointmentId)) return [3 /*break*/, 9];
                    return [4 /*yield*/, cancelAppointment(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('appointmentId', appointmentId), token)];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9:
                    dispatch({ type: 'SET_HAS_COMPLETED', payload: true });
                    setActiveRoute('completed');
                    return [3 /*break*/, 12];
                case 10:
                    error_5 = _a.sent();
                    _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].failed('appointments.selectionSteps.detailsOverview.formError');
                    return [3 /*break*/, 12];
                case 11:
                    dispatch({ type: 'RESET_RESCHEDULING' });
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); }, [isRescheduling, appointmentId, createAppointmentRequest]);
    var initialFormState = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        // If the user is logged in, prefill data from their MyAccount as readonly fields
        if (Object(_grandvision_auth__WEBPACK_IMPORTED_MODULE_8__[/* isDataSuccess */ "p"])(userData)) {
            var _a = userData.result, _b = _a.email, email = _b === void 0 ? '' : _b, _c = _a.personalDetails, personalDetails = _c === void 0 ? {} : _c, _d = _a.billingAddress, billingAddress = _d === void 0 ? {} : _d;
            return _grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* Util */ "D"].mergeComposedFormValueState(state.customerDetails, {
                personalDetails: userDataToFormState(__assign(__assign({}, personalDetails), { email: email })),
                billingAddress: userDataToFormState(billingAddress),
            });
        }
        // If the user is not logged in, filter out any previously prefilled fields
        return filterReadonlyState(state.customerDetails);
    }, [userData /* *NOT* state.customerDetails, to avoid circular updates */]);
    return loadingUser ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LoaderScreen */ "M"], null)) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StepDetailsOverview, __assign({}, rest, { isValid: formValid && hasConsent, isLoading: isLoading, hasCompleted: hasCompleted, onCustomerDetailsChange: handleCustomerDetailsChange, initialFormState: initialFormState, onCreateAppointment: handleCreateAppointment, notLoggedIn: notLoggedIn, signInMyAccountUrl: signInMyAccountUrl })));
};
var StepDetailsOverviewContainerWithChecksContext = function (props) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Provider, null,
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StepDetailsOverviewContainer, __assign({}, props)))); };
StepDetailsOverviewContainerWithChecksContext.displayName =
    'StepDetailsOverviewContainerWithChecksContext';

var ActiveTimeFilter = function (_a) {
    var className = _a.className, show = _a.show, text = _a.text, clearLabel = _a.clearLabel, onClear = _a.onClear, _b = _a.icon, icon = _b === void 0 ? 'close' : _b, rest = __rest(_a, ["className", "show", "text", "clearLabel", "onClear", "icon"]);
    return show ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('active-time-filter', className) }),
        text && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "active-time-filter__text" }, text),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", { className: "active-time-filter__button", type: "button", onClick: onClear },
            icon && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { className: "active-time-filter__button-icon", name: icon }),
            clearLabel))) : null;
};

var useActiveTimeFilter = function () {
    var dispatch = useAppointmentBookerContext().dispatch;
    var text = useTimeFilterString();
    var show = text.length > 0;
    var onClear = function () { return dispatch({ type: 'RESET_TIME_FILTER' }); };
    return {
        show: show,
        text: text,
        onClear: onClear,
    };
};
var ActiveTimeFilterContainer = function (props) {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var activeTimeFilter = useActiveTimeFilter();
    var clearLabel = intl.getLabel('appointments.activeTimeFilter.clear');
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ActiveTimeFilter, __assign({}, props, activeTimeFilter, { clearLabel: clearLabel }));
};

var TimeListerItem = function (_a) {
    var className = _a.className, selected = _a.selected, slot = _a.slot, onSelect = _a.onSelect, rest = __rest(_a, ["className", "selected", "slot", "onSelect"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", __assign({}, rest, { key: slot.from.toUTCString(), className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('time-lister-item', className, {
            'time-lister-item--selected': selected,
        }), onClick: function () { return onSelect(slot); } }), dateToLocalTime(slot.from)));
};

var TimeLister = function (_a) {
    var className = _a.className, selected = _a.selected, slots = _a.slots, onSelectTime = _a.onSelectTime, onSearchStoresByDate = _a.onSearchStoresByDate, _b = _a.loading, loading = _b === void 0 ? false : _b, rest = __rest(_a, ["className", "selected", "slots", "onSelectTime", "onSearchStoresByDate", "loading"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var items = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        return slots.map(function (slot) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TimeListerItem, { key: slot.from.toUTCString(), selected: !!selected && slot.from.getTime() === selected.from.getTime(), slot: slot, onSelect: onSelectTime })); });
    }, [slots, selected]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('time-lister', {
            'time-lister--loading': loading,
            'time-lister--no-results': !loading && !items.length,
        }, className) }),
        loading && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-lister__loader" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null))),
        !loading && items,
        !loading && !items.length && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-lister__no-results" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, intl.getLabel('appointments.noTimeSlots')),
            onSearchStoresByDate && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: intl.getLabel('appointments.findStoreForDay'), className: "time-lister__find-store", onClick: onSearchStoresByDate, variant: "ghost" }))))));
};

var DatePicker = function (_a) {
    var className = _a.className, _b = _a.loading, loading = _b === void 0 ? false : _b, timeSlots = _a.timeSlots, rangeTimeSlots = _a.rangeTimeSlots, checkRangeTimeSlots = _a.checkRangeTimeSlots, _c = _a.currentDate, currentDate = _c === void 0 ? new Date() : _c, todayProp = _a.today, selectedTimeSlot = _a.selectedTimeSlot, onSelectDate = _a.onSelectDate, onSelectTime = _a.onSelectTime, onRangeChange = _a.onRangeChange, onSearchStoresByDate = _a.onSearchStoresByDate, rest = __rest(_a, ["className", "loading", "timeSlots", "rangeTimeSlots", "checkRangeTimeSlots", "currentDate", "today", "selectedTimeSlot", "onSelectDate", "onSelectTime", "onRangeChange", "onSearchStoresByDate"]);
    var state = useAppointmentBookerContext().state;
    var _d = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(currentDate), 2), date = _d[0], setDate = _d[1];
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(selectedTimeSlot || timeSlots[0]), 2), time = _e[0], setTime = _e[1];
    var today = react__WEBPACK_IMPORTED_MODULE_0___default.a.useRef(todayProp || new Date());
    var dateRangeProvider = useDateRangeProvider(today.current);
    var timeFilter = state.timeFilter;
    var hasActiveTimeFilter = timeFilter.date.type !== 'any' || timeFilter.time.type !== 'any';
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return onSelectDateHandler(date); }, [date]);
    var onSelectDateHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (date) {
        setDate(date);
        onSelectDate(date);
    }, [onSelectDate]);
    var onSelectTimeHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (slot) {
        setTime(slot);
        onSelectTime(slot);
    }, [onSelectTime]);
    var onSearchStoresByDateHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return onSearchStoresByDate(date); }, [date]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return setDate(currentDate); }, [currentDate]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return setTime(selectedTimeSlot); }, [selectedTimeSlot]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('appointment-date-picker', { 'appointment-date-picker--loading': loading }, className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DateLister, { className: "appointment-date-picker__date-lister", selected: date, rangeTimeSlots: rangeTimeSlots, checkRangeTimeSlots: checkRangeTimeSlots, rangeProvider: dateRangeProvider, onSelectDate: onSelectDateHandler, onRangeChange: onRangeChange }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TimeLister, { selected: time, loading: loading, slots: timeSlots, onSelectTime: onSelectTimeHandler, onSearchStoresByDate: hasActiveTimeFilter ? undefined : onSearchStoresByDateHandler })));
};

var StepSelectDate = function (_a) {
    var selectedTimeSlot = _a.selectedTimeSlot, slots = _a.slots, rangeSlots = _a.rangeSlots, checkRangeTimeSlots = _a.checkRangeTimeSlots, error = _a.error, loading = _a.loading, isFullScreen = _a.isFullScreen, currentDate = _a.currentDate, onChangeRange = _a.onChangeRange, onDateSelect = _a.onDateSelect, onTimeSearch = _a.onTimeSearch, showTimeSearch = _a.showTimeSearch, onTimeSelect = _a.onTimeSelect, onSearchStoresByDate = _a.onSearchStoresByDate, onNextStep = _a.onNextStep, _b = _a.isRescheduling, isRescheduling = _b === void 0 ? false : _b;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('select-date', { 'select-date--selected': selectedTimeSlot }) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h2", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('select-date__heading', isFullScreen ? 'h3' : 'h4') }, intl.getLabel(isRescheduling
            ? 'appointments.selectDate.rescheduling.heading'
            : 'appointments.selectDate.heading')),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ActiveTimeFilterContainer, { className: "select-date__active-time-filter" }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "select-date__content" },
            error ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", null,
                "Error: ",
                error.message)) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DatePicker, { className: "select-date__picker", loading: loading, currentDate: currentDate, selectedTimeSlot: selectedTimeSlot, timeSlots: slots, rangeTimeSlots: rangeSlots, checkRangeTimeSlots: checkRangeTimeSlots, onSelectDate: onDateSelect, onSelectTime: onTimeSelect, onRangeChange: onChangeRange, onSearchStoresByDate: onSearchStoresByDate }),
                showTimeSearch && onTimeSearch && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "select-date__search-specific-time-button", caption: intl.getLabel('appointments.selectionSteps.type.specificTime'), variant: "outline", icon: "clock", onClick: onTimeSearch })))),
            selectedTimeSlot && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ContextualConfirmation, { buttonLabel: intl.getLabel('appointments.selectionSteps.date.stepNext'), onConfirm: onNextStep, subscript: intl.getLabel('appointments.selectionSteps.date.subscript') },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "select-date__confirmation-content" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "select-date__confirmation-title" }, dateToDayNumberMonthYearString(selectedTimeSlot.from)),
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "select-date__confirmation-subtitle" }, datesToLocalTimeSpan(selectedTimeSlot.from, selectedTimeSlot.until) /* TODO: Implement dynamic am-pm/24h */)))))));
};

var useInitialDate = function () {
    var _a = useAppointmentBookerContext().state, timeFilter = _a.timeFilter, selectedTimeSlot = _a.selectedTimeSlot;
    var date = timeFilter.date;
    var now = new Date();
    var today = react__WEBPACK_IMPORTED_MODULE_0___default.a.useRef(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        var initialDate = today.current;
        switch (date.type) {
            case 'single':
                initialDate = new Date(date.value);
                break;
            case 'range':
                initialDate = new Date(date.value.start);
                break;
            case 'dynamic':
                var today_1 = new Date();
                var value = date.value === 'today' ? today_1 : shiftDate(today_1, 'day');
                initialDate = new Date(value);
        }
        return selectedTimeSlot && selectedTimeSlot.from.getTime() > today.current.getTime()
            ? selectedTimeSlot.from
            : initialDate;
    }, [date]);
};

var dateToQueryVariable = function (date) { return toLocalDate(date); };
var processTimeSlots = function (data, range, timeFilter) {
    var timeSlots = data && data.length ? getSlotsByTimeFilter(timeSlotResponseToTimeSlots(data), timeFilter) : [];
    var sortedTimeSlots = timeSlotsByDay(timeSlots);
    return range.map(function (date) { return sortedTimeSlots.find(function (collection) { return isSameDay(date, collection[0].from); }) || []; });
};
var StepSelectDateContainer = function (_a) {
    var apiUrl = _a.apiUrl, rest = __rest(_a, ["apiUrl"]);
    var _b = useAppointmentBookerContext(), state = _b.state, dispatch = _b.dispatch, _c = _b.featureToggles, withTimeSearch = _c.withTimeSearch, withTimeSlotByWeekCheck = _c.withTimeSlotByWeekCheck;
    var selectedAppointmentType = state.selectedAppointmentType, selectedStore = state.selectedStore, appSelectedDate = state.selectedDate, selectedTimeSlot = state.selectedTimeSlot, timeFilter = state.timeFilter, openEditPanel = state.openEditPanel, openTimeSearchDialog = state.openTimeSearchDialog, isRescheduling = state.isRescheduling;
    var _d = __read(useRouteState(), 2), activeRoute = _d[0], setActiveRoute = _d[1];
    var initialDate = useInitialDate();
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(initialDate), 2), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState([]), 2), range = _f[0], setRange = _f[1];
    var appointmentTypeId = selectedAppointmentType ? selectedAppointmentType.id : null;
    var code = selectedStore ? selectedStore.code : undefined;
    var isFullScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() !== _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var dateTimeSlotsSource = useTimeSlots(apiUrl);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (code && appointmentTypeId && selectedDate) {
            dateTimeSlotsSource.setQuery({
                storeCode: code,
                appointmentTypeId: appointmentTypeId,
                startDate: dateToQueryVariable(selectedDate),
                endDate: dateToQueryVariable(selectedDate),
            });
        }
    }, [code, appointmentTypeId, selectedDate]);
    var activeTimeSearch = timeFilter.date.type !== 'any' || timeFilter.time.type !== 'any';
    var allowRangeTimeSlotRequest = Boolean(withTimeSlotByWeekCheck) || activeTimeSearch;
    var rangeTimeSlotsSource = useTimeSlots(apiUrl, { skip: !allowRangeTimeSlotRequest });
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (code && appointmentTypeId && (initialDate || (range && range.length))) {
            rangeTimeSlotsSource.setQuery({
                storeCode: code,
                appointmentTypeId: appointmentTypeId,
                startDate: dateToQueryVariable(range[0] || initialDate),
                endDate: dateToQueryVariable(range[6] || shiftDate(initialDate, 'day', 6)),
            });
        }
    }, [code, appointmentTypeId, initialDate, range]);
    var error = dateTimeSlotsSource.error || rangeTimeSlotsSource.error;
    var loading = dateTimeSlotsSource.loading || (allowRangeTimeSlotRequest && rangeTimeSlotsSource.loading);
    var timeSlots = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return processTimeSlots(dateTimeSlotsSource.data, [selectedDate], timeFilter)[0] || []; }, [dateTimeSlotsSource.data, selectedDate, timeFilter]);
    var rangeTimeSlots = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return processTimeSlots(rangeTimeSlotsSource.data, range, timeFilter); }, [rangeTimeSlotsSource.data, range, timeFilter]);
    var onSelectDate = function (date) {
        return setSelectedDate(function (oldDate) { return (oldDate && isSameDay(oldDate, date) ? oldDate : date); });
    };
    var onRangeChange = function (range) { return setRange(range); };
    var onSelectTime = function (slot) {
        return dispatch({ type: 'SET_SELECTED_TIME_SLOT', payload: slot });
    };
    var onSearchStoresByDate = function (date) {
        dispatch({ type: 'SET_SELECTED_DATE', payload: date });
        dispatch({ type: 'SET_EDIT_PANEL_OPEN', payload: true });
    };
    var onNextStep = function () { return setActiveRoute('details'); };
    var onTimeSearch = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return dispatch({ type: 'SET_TIME_SEARCH_DIALOG_OPEN', payload: true }); }, []);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return window.scrollTo(0, 0); }, []);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!openEditPanel) {
            setSelectedDate(appSelectedDate || selectedDate);
            if (appSelectedDate) {
                dispatch({ type: 'RESET_SELECTED_DATE' });
            }
        }
    }, [openEditPanel]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!openTimeSearchDialog) {
            setSelectedDate(appSelectedDate || selectedDate);
            if (appSelectedDate) {
                dispatch({ type: 'RESET_SELECTED_DATE' });
            }
        }
    }, [openTimeSearchDialog]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StepSelectDate, __assign({}, rest, { currentDate: selectedDate, loading: loading, isFullScreen: isFullScreen, error: error, rangeSlots: rangeTimeSlots, checkRangeTimeSlots: allowRangeTimeSlotRequest, slots: timeSlots, selectedTimeSlot: selectedTimeSlot, onChangeRange: onRangeChange, onDateSelect: onSelectDate, onTimeSelect: onSelectTime, onSearchStoresByDate: onSearchStoresByDate, onNextStep: onNextStep, onTimeSearch: onTimeSearch, showTimeSearch: !!withTimeSearch, isRescheduling: isRescheduling })));
};

var StepSelectType = function (_a) {
    var loading = _a.loading, typeMatrix = _a.typeMatrix, onNextStep = _a.onNextStep, onTimeSearch = _a.onTimeSearch, canContinue = _a.canContinue, isFullScreen = _a.isFullScreen, error = _a.error, showTimeSearch = _a.showTimeSearch, className = _a.className, rest = __rest(_a, ["loading", "typeMatrix", "onNextStep", "onTimeSearch", "canContinue", "isFullScreen", "error", "showTimeSearch", "className"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('select-type', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h2", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('select-type__heading', isFullScreen ? 'h3' : 'h4') }, intl.getLabel('appointments.selectionSteps.selectType.heading')),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "select-type__content" }, loading ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LoaderScreen */ "M"], null)) : error ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "select-type__error" },
            "Error: $",
            error.message)) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentTypeTreeContainer, { typeMatrix: typeMatrix }))),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "select-type__controls" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "select-type__find-store-button", caption: intl.getLabel('appointments.selectionSteps.type.stepNext'), onClick: onNextStep, disabled: !canContinue, icon: "location-pin" }),
            showTimeSearch && onTimeSearch && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "select-type__search-specific-time-button", caption: intl.getLabel('appointments.selectionSteps.type.specificTime'), variant: "outline", icon: "clock", onClick: onTimeSearch, disabled: !canContinue })))));
};

var scrollToTop = function () { return window.scrollTo(0, 0); };
var StepSelectTypeContainer = function (_a) {
    var apiUrl = _a.apiUrl, rest = __rest(_a, ["apiUrl"]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(scrollToTop, []);
    var _b = useAppointmentBookerContext(), state = _b.state, withTimeSearch = _b.featureToggles.withTimeSearch, dispatchAppAction = _b.dispatch;
    var _c = useAppointmentTypeContext(), loading = _c.loading, typeMatrix = _c.typeMatrix, error = _c.error;
    var isFullScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() !== _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var _d = __read(useRouteState(), 2), activeRoute = _d[0], setActiveRoute = _d[1];
    var queryParams = state.queryParams, selectedAppointmentType = state.selectedAppointmentType, selectedStore = state.selectedStore;
    var handleNextStep = function () {
        dispatchAppAction({ type: 'RESET_TIME_FILTER' });
        setActiveRoute(queryParams && (queryParams.store || queryParams.storeId) && selectedStore
            ? 'timeslot'
            : 'store');
    };
    var handleTimeSearch = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return dispatchAppAction({ type: 'SET_TIME_SEARCH_DIALOG_OPEN', payload: true }); }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StepSelectType, __assign({}, rest, { loading: loading, typeMatrix: typeMatrix || { properties: [] }, onNextStep: handleNextStep, onTimeSearch: handleTimeSearch, canContinue: !!selectedAppointmentType, isFullScreen: isFullScreen, showTimeSearch: !!withTimeSearch, error: error })));
};

var MapViewContainer$1 = function (_a) {
    var className = _a.className, view = _a.view, onMapClick = _a.onMapClick, rest = __rest(_a, ["className", "view", "onMapClick"]);
    var appState = useAppointmentBookerContext().state;
    var mapState = useMapContext().state;
    var _b = useStoresContext(), storesState = _b.state, dispatchStoresAction = _b.dispatch;
    var userLocation = appState.userLocation;
    var markers = mapState.markers, center = mapState.center, highlight = mapState.highlight, setUseUserLocation = mapState.setUseUserLocation;
    var storeList = storesState.list, activeStore = storesState.active;
    var onSelectMarker = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (code) {
        dispatchStoresAction({
            type: 'SET_ACTIVE_STORE',
            payload: storeList.find(function (store) { return store.code === code; }) || null,
        });
    }, [storeList]);
    var onClickUseMyLocation = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        dispatchStoresAction({ type: 'RESET_ACTIVE_STORE' });
        dispatchStoresAction({ type: 'RESET_STORE_FILTER_QUERY' });
        setUseUserLocation(true);
    }, [setUseUserLocation]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MapView, __assign({}, rest, { center: center, highlight: highlight, markers: markers, onSelectMarker: onSelectMarker, onClickUseMyLocation: onClickUseMyLocation, showUseMyLocation: !activeStore, onMapClick: onMapClick, userLocation: userLocation, view: view, withZoom: false })));
};

var InputName = 'store-search-input__query';
var getInput = function () { return document.querySelector("[name=\"" + InputName + "\"]"); };
var StoreSearchInput = function (_a) {
    var _b;
    var className = _a.className, inputState = _a.inputState, onQueryChange = _a.onQueryChange, onFocus = _a.onFocus, onClear = _a.onClear, onSubmit = _a.onSubmit, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.query, query = _d === void 0 ? '' : _d, _e = _a.activeValue, activeValue = _e === void 0 ? '' : _e;
    var _f = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(false), 2), hasFocus = _f[0], setHasFocus = _f[1];
    var onChangeHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (event) { return onQueryChange(event.value); }, [onQueryChange]);
    var onSubmitHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (e) {
        e.preventDefault();
        onSubmit();
        var input = getInput();
        if (input) {
            input.blur();
        }
    }, [onSubmit]);
    var onFocusHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        onFocus();
        var input = getInput();
        if (input) {
            input.focus();
        }
        setHasFocus(true);
    }, []);
    var onBlurHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return setHasFocus(false); }, []);
    var onClearHandler = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        onClear();
        var input = getInput();
        if (input) {
            input.focus();
        }
    }, [onClear]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("form", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-search-input', className), noValidate: true, autoComplete: "off", onSubmit: onSubmitHandler },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* FormControl */ "k"], { key: "INPUT--" + inputState, id: InputName, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_b = {},
                _b[InputName + "--transparent"] = !hasFocus && activeValue,
                _b)), type: "search", required: false, onBlur: onBlurHandler, onChange: onChangeHandler, initialState: { value: query }, placeholder: placeholder }),
        !hasFocus && activeValue ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-search-input__active-value", role: "button", onClick: onFocusHandler }, activeValue),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", { className: "store-search-input__button store-search-input__clear", type: "button", onClick: onClearHandler },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "close" })))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", { className: "store-search-input__button store-search-input__submit", type: "submit" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "search" })))));
};

var StoreSearchButton = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-search-list-item__button', className) }, rest)));
};

var StoreSearchList = function (_a) {
    var className = _a.className, storeSuggestions = _a.storeSuggestions, locationSuggestions = _a.locationSuggestions, onSelectStore = _a.onSelectStore, onSelectLocation = _a.onSelectLocation, useUserLocation = _a.useUserLocation, userLocationLabel = _a.userLocationLabel, onClickUseMyLocation = _a.onClickUseMyLocation;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("ul", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-search-list', className) },
        !useUserLocation && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { className: "store-search-list-item__use-my-location-wrapper" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { variant: "ghost", size: "small", icon: "gps", className: "store-search-list__use-my-location-button", onClick: onClickUseMyLocation, caption: userLocationLabel }))),
        storeSuggestions.map(function (store) {
            var distance = useUserLocation && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* hasDistance */ "t"])(store) && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* formatDistance */ "k"])(store.distance, intl.distanceUnit);
            return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { key: store.code, className: "store-search-list-item" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSearchButton, { caption: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null,
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-search-list-item__button-store-text" }, store.town + " - " + store.storeName),
                        distance && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-search-list-item__button-store-distance" }, distance))), icon: "store", onClick: function () { return onSelectStore(store); }, variant: "outline" })));
        }),
        locationSuggestions.slice(0, 7 - storeSuggestions.length).map(function (location) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", { key: location.join('|'), className: "store-search-list-item" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSearchButton, { className: "store-search-list-item__button--location", caption: location.join(' - '), icon: "location", onClick: function () { return onSelectLocation(location); }, variant: "ghost" }))); })));
};

var StoreSelectSearchForm = function (_a) {
    var className = _a.className, placeholder = _a.placeholder, query = _a.query, activeFormValue = _a.activeFormValue, inputState = _a.inputState, showSuggestions = _a.showSuggestions, storeSuggestions = _a.storeSuggestions, locationSuggestions = _a.locationSuggestions, useUserLocation = _a.useUserLocation, userLocationLabel = _a.userLocationLabel, userLocationError = _a.userLocationError, showStaticUserLocationButton = _a.showStaticUserLocationButton, userLocationDescription = _a.userLocationDescription, onQueryChange = _a.onQueryChange, onClickStore = _a.onClickStore, onClickLocation = _a.onClickLocation, onClickUseMyLocation = _a.onClickUseMyLocation, onSubmit = _a.onSubmit, onFocus = _a.onFocus, onClear = _a.onClear, rest = __rest(_a, ["className", "placeholder", "query", "activeFormValue", "inputState", "showSuggestions", "storeSuggestions", "locationSuggestions", "useUserLocation", "userLocationLabel", "userLocationError", "showStaticUserLocationButton", "userLocationDescription", "onQueryChange", "onClickStore", "onClickLocation", "onClickUseMyLocation", "onSubmit", "onFocus", "onClear"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-select-search-form', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSearchInput, { placeholder: placeholder, query: query, activeValue: activeFormValue, inputState: inputState, onQueryChange: onQueryChange, onSubmit: onSubmit, onFocus: onFocus, onClear: onClear }),
        showSuggestions && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSearchList, { className: "store-select-search-form__search-list", storeSuggestions: storeSuggestions, locationSuggestions: locationSuggestions, onSelectStore: onClickStore, onSelectLocation: onClickLocation, onClickUseMyLocation: onClickUseMyLocation, useUserLocation: useUserLocation, userLocationLabel: userLocationLabel, userLocationError: userLocationError })),
        showStaticUserLocationButton && !useUserLocation && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "store-select-search-form__user-location" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "store-select-search-form__user-location-content" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { variant: "ghost", size: "small", icon: "gps", className: "store-select-search-form__user-location-button", onClick: onClickUseMyLocation, caption: userLocationLabel }),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "store-select-search-form__user-location-description" }, userLocationDescription))))));
};

var PLACE_PREDICTION_DEBOUNCE_TIMEOUT = 500; // ms
var StoreSelectSearchFormContainer = function (rest) {
    var apiConfig = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useApiConfig */ "N"])();
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var _a = useAppointmentBookerContext(), dispatchAppAction = _a.dispatch, storeSearchEnabled = _a.featureToggles.storeSearchEnabled;
    var _b = __read(useRouteState(), 2), activeRoute = _b[0], setActiveRoute = _b[1];
    var _c = useStoresContext(), storesState = _c.state, dispatchStoresAction = _c.dispatch;
    var mapState = useMapContext().state;
    var filterQuery = storesState.filterQuery, storeList = storesState.list, activeStore = storesState.active, location = storesState.location;
    var userLocation = mapState.userLocation, useUserLocation = mapState.useUserLocation, setUseUserLocation = mapState.setUseUserLocation, useUserLocationError = mapState.useUserLocationError;
    var _d = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(''), 2), query = _d[0], setQuery = _d[1];
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(''), 2), locationQuery = _e[0], setLocationQuery = _e[1];
    var _f = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState('TYPING'), 2), inputState = _f[0], setInputState = _f[1];
    var _g = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(false), 2), showSuggestions = _g[0], setShowSuggestions = _g[1];
    var isFullScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() !== _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var showStaticUserLocationButton = isFullScreen && !useUserLocation && !filterQuery.length;
    var getCoordinates = Object(_grandvision_stores__WEBPACK_IMPORTED_MODULE_19__[/* useGetCoordinates */ "g"])();
    var storeSuggestions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return storeSearchEnabled && query && !filterQuery
            ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* findNearestCoordinates */ "j"])((userLocation && { lat: userLocation.lat, lon: userLocation.lng }) || {
                lat: undefined,
                lon: undefined,
            }, query ? storeList.filter(function (store) { return _grandvision_stores__WEBPACK_IMPORTED_MODULE_19__[/* Util */ "f"].searchStore(store, query); }) : storeList, { limit: 5 })
            : [];
    }, [storeList, location, userLocation, query, filterQuery]);
    Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* useDebouncedEffect */ "I"])(function () { return setLocationQuery(query); }, PLACE_PREDICTION_DEBOUNCE_TIMEOUT, [query]);
    var locationsOptions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({ skip: !locationQuery }); }, [locationQuery]);
    var _h = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_7__[/* Location */ "d"].getPlacePredictions, locationsOptions, apiConfig.locationsUrl, react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({ place: locationQuery }); }, [locationQuery]), apiConfig.apiKey), 3), loadingLocations = _h[0], locationsData = _h[1], loadingLocationsError = _h[2];
    var locationSuggestions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return (locationsData ? locationsData.places : []); }, [
        locationsData,
    ]);
    var activeFormValue = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        if (filterQuery) {
            return filterQuery;
        }
        else if (location) {
            return location.place.join(' ');
        }
        else if (useUserLocation && !query.length) {
            return intl.getLabel('appointments.storeSelection.userLocationFormValue');
        }
        return '';
    }, [filterQuery, location, useUserLocation, query, intl]);
    // InputState is being used to force a render of the input field, since updating initialValue will not do that.
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () { return (inputState === 'EMPTY' ? setInputState('TYPING') : undefined); }, [
        inputState,
    ]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (!activeStore && query.length) {
            dispatchStoresAction({ type: 'CHANGE_STORE_FILTER_QUERY', payload: query });
        }
    }, [activeStore]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        return dispatchAppAction({
            type: 'setState',
            key: 'allowOverflow',
            value: showSuggestions && !filterQuery.length,
        });
    }, [showSuggestions, filterQuery]);
    var onQueryChange = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (newQuery) {
        return setQuery(function (oldQuery) {
            if (newQuery === oldQuery) {
                return oldQuery;
            }
            dispatchStoresAction({ type: 'RESET_ACTIVE_STORE' });
            dispatchStoresAction({ type: 'RESET_STORE_FILTER_QUERY' });
            setInputState('TYPING');
            setShowSuggestions(newQuery.length > 2);
            return newQuery;
        });
    }, []);
    var onClickStore = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (store) {
        setShowSuggestions(false);
        if (!isFullScreen) {
            dispatchStoresAction({ type: 'SET_ACTIVE_STORE', payload: store });
        }
        else {
            dispatchAppAction({ type: 'setState', key: 'selectedStore', value: store });
            setActiveRoute('timeslot');
        }
    }, []);
    var selectLocation = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (location) {
        setQuery('');
        setShowSuggestions(false);
        getCoordinates(apiConfig.locationsUrl, { query: location.join(', ') }, apiConfig.apiKey).then(function (_a) {
            var coordinates = _a.coordinates;
            return dispatchStoresAction({
                type: 'SET_LOCATION',
                payload: { place: location, position: coordinates },
            });
        }, function (error) {
            console.error('Location getCoordinates failed:', error);
        });
    }, [apiConfig.locationsUrl]);
    var onClickUseMyLocation = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        dispatchStoresAction({ type: 'RESET_ACTIVE_STORE' });
        dispatchStoresAction({ type: 'RESET_STORE_FILTER_QUERY' });
        setUseUserLocation(true);
    }, [setUseUserLocation]);
    var onSubmit = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        if (storeSearchEnabled) {
            dispatchStoresAction({ type: 'CHANGE_STORE_FILTER_QUERY', payload: query });
            setShowSuggestions(false);
        }
        else if (locationSuggestions.length) {
            selectLocation(locationSuggestions[0]);
            setShowSuggestions(false);
        }
    }, [query]);
    var onFocus = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        dispatchStoresAction({ type: 'RESET_LOCATION' });
    }, []);
    var onClear = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        /*
         * Using the user location will be set to false in case:
         * - It was already false
         * - It was true and:
         *   - The user has not submitted the store search form (filterQuery.length === 0)
         *   - The user has not selected a location (location === null)
         *   - The store search field does not contain a query (query.length === 0)
         *
         * These cases usually occur when the user has clicked the clear button before,
         * removing any active filterQuery, un-setting a selected location and resetting
         * the query value (see code after setUseUserLocation).
         */
        setUseUserLocation(useUserLocation && (filterQuery.length > 0 || location !== null || query.length > 0));
        dispatchStoresAction({ type: 'RESET_STORE_FILTER_QUERY' });
        dispatchStoresAction({ type: 'RESET_LOCATION' });
        setQuery('');
    }, [filterQuery, location, query]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelectSearchForm, __assign({ placeholder: intl.getLabel('appointments.storeSelection.searchPlaceholder'), query: query, activeFormValue: activeFormValue, inputState: inputState, userLocationLabel: intl.getLabel('stores.actions.useMyLocation'), showSuggestions: showSuggestions, storeSuggestions: storeSuggestions, locationSuggestions: locationSuggestions, useUserLocation: useUserLocation, userLocationError: useUserLocationError, showStaticUserLocationButton: showStaticUserLocationButton, userLocationDescription: intl.getLabel('appointments.storeSelection.userLocation.description'), onQueryChange: onQueryChange, onClickStore: onClickStore, onClickLocation: selectLocation, onClickUseMyLocation: onClickUseMyLocation, onSubmit: onSubmit, onFocus: onFocus, onClear: onClear }, rest)));
};

var StoreCarouselItem = function (_a) {
    var className = _a.className, store = _a.store, onSelectStore = _a.onSelectStore, _b = _a.checkAvailability, checkAvailability = _b === void 0 ? false : _b, _c = _a.showAvailability, showAvailability = _c === void 0 ? false : _c, _d = _a.showAvailabilityCount, showAvailabilityCount = _d === void 0 ? false : _d, rest = __rest(_a, ["className", "store", "onSelectStore", "checkAvailability", "showAvailability", "showAvailabilityCount"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])().getLabel;
    var state = useAppointmentBookerContext().state;
    var userLocation = state.userLocation;
    var availability = checkAvailability ? getAvailability(store) : 0;
    var onClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () { return onSelectStore(store); }, [store]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-carousel-item', className, {
            'store-carousel-item--disabled': checkAvailability && !availability,
        }) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSummary, { store: store, availability: availability, showAvailability: showAvailability, showAvailabilityCount: showAvailabilityCount, showDistance: Boolean(userLocation) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", { className: "button button--primary store-carousel-item__button", onClick: onClick, disabled: checkAvailability && !availability }, getLabel('appointments.selectionSteps.selectStore.selectStore'))));
};

var getIndex = function (stores, activeStore) {
    return activeStore
        ? Math.max(0, stores.findIndex(function (store) { return store.code === activeStore.code; }))
        : 0;
};
var VirtualizeSwipeableViews$1 = Object(react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22__["bindKeyboard"])(Object(react_swipeable_views_utils__WEBPACK_IMPORTED_MODULE_22__["virtualize"])(react_swipeable_views__WEBPACK_IMPORTED_MODULE_21___default.a));
var StoreSelectionCarousel = function (_a) {
    var className = _a.className, stores = _a.stores, activeStore = _a.activeStore, onSelectStore = _a.onSelectStore, onSaveStore = _a.onSaveStore, _b = _a.showAvailability, showAvailability = _b === void 0 ? false : _b, _c = _a.showAvailabilityCount, showAvailabilityCount = _c === void 0 ? false : _c, _d = _a.checkAvailability, checkAvailability = _d === void 0 ? false : _d, rest = __rest(_a, ["className", "stores", "activeStore", "onSelectStore", "onSaveStore", "showAvailability", "showAvailabilityCount", "checkAvailability"]);
    var _e = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(getIndex(stores, activeStore)), 2), index = _e[0], setIndex = _e[1];
    var slideRenderer = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (_a) {
        var index = _a.index, key = _a.key;
        var store = stores[index];
        return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreCarouselItem, { key: key, className: "store-selection-carousel-item", store: store, onSelectStore: onSaveStore, checkAvailability: checkAvailability, showAvailabilityCount: showAvailabilityCount, showAvailability: showAvailability }));
    }, [stores, onSaveStore]);
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
        var newIndex = getIndex(stores, activeStore);
        if (newIndex === index) {
            return;
        }
        setIndex(newIndex);
    }, [activeStore, stores]);
    var onChangeIndex = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (newIndex) {
        setIndex(newIndex);
        onSelectStore(stores[newIndex]);
    }, [onSelectStore, stores]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-selection-carousel', className) }), stores.length > 0 && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(VirtualizeSwipeableViews$1, { index: index, slideCount: stores.length, enableMouseEvents: true, slideRenderer: slideRenderer, onChangeIndex: onChangeIndex }))));
};

var TogglePanel = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClickToggle = _a.onClickToggle, rest = __rest(_a, ["children", "isOpen", "onClickToggle"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var _b = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(false), 2), isScrolling = _b[0], setIsScrolling = _b[1];
    var onScroll = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (e) { return setIsScrolling(e.currentTarget.scrollTop > 0); }, []);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("toggle-panel", {
            'toggle-panel--open': isOpen,
            'toggle-panel--scrolling': isScrolling,
        }) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "toggle-panel__content", onScroll: onScroll }, children),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", { className: "toggle-panel__button", onClick: onClickToggle },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "list", className: "toggle-panel__icon" }),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "toggle-panel__label" }, intl.getLabel('appointments.showList')))));
};

var StoreSelection = function (_a) {
    var className = _a.className, view = _a.view, _b = _a.checkAvailability, checkAvailability = _b === void 0 ? true : _b, filteredStores = _a.filteredStores, activeStore = _a.activeStore, selectedStore = _a.selectedStore, isFullScreen = _a.isFullScreen, showFilterResults = _a.showFilterResults, panelOpen = _a.panelOpen, _c = _a.showShowMoreButton, showShowMoreButton = _c === void 0 ? false : _c, onSelectStore = _a.onSelectStore, onSaveStore = _a.onSaveStore, onClickTogglePanel = _a.onClickTogglePanel, onShowMore = _a.onShowMore, onMapClick = _a.onMapClick, rest = __rest(_a, ["className", "view", "checkAvailability", "filteredStores", "activeStore", "selectedStore", "isFullScreen", "showFilterResults", "panelOpen", "showShowMoreButton", "onSelectStore", "onSaveStore", "onClickTogglePanel", "onShowMore", "onMapClick"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var isMobile = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() === _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-selection', { 'store-selection--with-results': showFilterResults }, className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h2", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('store-selection__heading', isFullScreen ? 'h3' : 'h4') }, intl.getLabel('appointments.storeSelection.heading')),
        isMobile && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MapViewContainer$1, { view: view, onMapClick: onMapClick }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelectSearchFormContainer, null),
        showFilterResults &&
            (isFullScreen || view === 'list' ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TogglePanel, { isOpen: panelOpen, onClickToggle: onClickTogglePanel }, filteredStores && filteredStores.length > 0 ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                isMobile && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "store-selection__list-title" },
                    intl.getLabel('appointments.storeSelection.listTitle'),
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* IconButton */ "w"], { onClick: onClickTogglePanel },
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { name: "chevron-down" })))),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelectionList, { onSelectStore: onSaveStore, selectedStore: selectedStore, stores: filteredStores, checkAvailability: checkAvailability, showAvailability: checkAvailability, showAvailabilityCount: checkAvailability }),
                showShowMoreButton && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "store-selection__show-more", onClick: onShowMore, caption: intl.getLabel('appointments.storeSelection.showMore'), variant: "ghost" })))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("p", { className: "store-selection__no-results" }, intl.getLabel('appointments.storeSelection.noResults'))))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelectionCarousel, { onSelectStore: onSelectStore, onSaveStore: onSaveStore, activeStore: activeStore, stores: filteredStores, checkAvailability: checkAvailability, showAvailability: checkAvailability, showAvailabilityCount: checkAvailability })))));
};

var StoreLoadSize = 5;
var StoreSelectionContainer = function (rest) {
    var _a = useAppointmentBookerContext(), appState = _a.state, dispatchAppAction = _a.dispatch;
    var _b = useStoresContext(), storesState = _b.state, dispatchStoresAction = _b.dispatch;
    var selectedStore = appState.selectedStore;
    var filterCount = storesState.filterCount, filterQuery = storesState.filterQuery, storeList = storesState.list, filteredStores = storesState.filtered, activeStore = storesState.active, activeLocation = storesState.location, allowSlotUsage = storesState.allowSlotUsage;
    var _c = __read(useRouteState(), 2), activeRoute = _c[0], setActiveRoute = _c[1];
    var userLocation = usePosition(true).position;
    var isFullScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() !== _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var _d = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false), 2), panelOpened = _d[0], setPanelOpened = _d[1];
    var showFilterResults = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        return activeStore !== null ||
            activeLocation !== null ||
            filterQuery.length > 0 ||
            userLocation !== undefined;
    }, [activeStore, activeLocation, filterQuery, userLocation]);
    var showShowMoreButton = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return filteredStores.length !== storeList.length && filteredStores.length >= filterCount; }, [filteredStores, storeList, filterCount]);
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () { return setPanelOpened(filterQuery.length > 0 || activeLocation !== null); }, [
        filterQuery,
        activeLocation,
    ]);
    var onSelectStore = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (store) {
        dispatchStoresAction({
            type: 'SET_ACTIVE_STORE',
            payload: store,
        });
    }, []);
    var onSaveStore = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (store) {
        dispatchAppAction({ type: 'RESET_SELECTED_TIME_SLOT' });
        dispatchAppAction({ type: 'SET_SELECTED_STORE', payload: store });
        setActiveRoute('timeslot');
    }, []);
    var onClickTogglePanel = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () { return setPanelOpened(!panelOpened); }, [panelOpened]);
    var onMapClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        if (panelOpened) {
            setPanelOpened(false);
        }
        else if (activeStore) {
            dispatchStoresAction({ type: 'RESET_ACTIVE_STORE' });
            setPanelOpened(true);
        }
    }, [panelOpened, activeStore]);
    var onShowMore = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        return filterCount < storeList.length &&
            dispatchStoresAction({
                type: 'CHANGE_STORE_FILTER_COUNT',
                payload: Math.min(filterCount + StoreLoadSize, storeList.length),
            });
    }, [storeList.length, filterCount]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoreSelection, __assign({}, rest, { view: !activeStore ? 'list' : 'carousel', checkAvailability: allowSlotUsage, selectedStore: selectedStore || null, activeStore: activeStore, filteredStores: filteredStores, isFullScreen: isFullScreen, showFilterResults: showFilterResults, panelOpen: panelOpened, showShowMoreButton: showShowMoreButton, onSelectStore: onSelectStore, onSaveStore: onSaveStore, onClickTogglePanel: onClickTogglePanel, onMapClick: onMapClick, onShowMore: onShowMore })));
};

var PreferenceOption = function (_a) {
    var className = _a.className, children = _a.children, active = _a.active, iconLeft = _a.iconLeft, iconRight = _a.iconRight, onClick = _a.onClick, rest = __rest(_a, ["className", "children", "active", "iconLeft", "iconRight", "onClick"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('preference-option', className, {
            'preference-option--active': active,
        }), onClick: onClick }),
        iconLeft && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { className: "preference-option__icon preference-option__icon--left", name: iconLeft })),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "preference-option__text" }, children),
        iconRight && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "b"], { className: "preference-option__icon preference-option__icon--right", name: iconRight }))));
};

var TimeSlotPreference = function (_a) {
    var className = _a.className, activeFromOption = _a.activeFromOption, activeUntilOption = _a.activeUntilOption, slots = _a.slots, confirmButtonLabel = _a.confirmButtonLabel, onClickToday = _a.onClickToday, onClickTomorrow = _a.onClickTomorrow, onClickAnyDay = _a.onClickAnyDay, onClickSelectTime = _a.onClickSelectTime, onClickAnyTime = _a.onClickAnyTime, fromOptions = _a.fromOptions, untilOptions = _a.untilOptions, handleChangeFrom = _a.handleChangeFrom, handleChangeUntil = _a.handleChangeUntil, onSelectStartDate = _a.onSelectStartDate, onSelectEndDate = _a.onSelectEndDate, onClear = _a.onClear, onSubmit = _a.onSubmit, startDate = _a.startDate, endDate = _a.endDate, isTodayActive = _a.isTodayActive, isTomorrowActive = _a.isTomorrowActive, isAnyDayActive = _a.isAnyDayActive, hasActiveRange = _a.hasActiveRange, canClearFilter = _a.canClearFilter, timeSelected = _a.timeSelected, rest = __rest(_a, ["className", "activeFromOption", "activeUntilOption", "slots", "confirmButtonLabel", "onClickToday", "onClickTomorrow", "onClickAnyDay", "onClickSelectTime", "onClickAnyTime", "fromOptions", "untilOptions", "handleChangeFrom", "handleChangeUntil", "onSelectStartDate", "onSelectEndDate", "onClear", "onSubmit", "startDate", "endDate", "isTodayActive", "isTomorrowActive", "isAnyDayActive", "hasActiveRange", "canClearFilter", "timeSelected"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var isMobile = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() === _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var renderDateOptions = function () {
        return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PreferenceOption, { className: "preference-option__today", active: isTodayActive, onClick: onClickToday }, intl.getLabel('appointments.timeSearch.today')),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PreferenceOption, { className: "preference-option__tomorrow", active: isTomorrowActive, onClick: onClickTomorrow }, intl.getLabel('appointments.timeSearch.tomorrow')),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PreferenceOption, { className: "preference-option__any-day", active: isAnyDayActive, onClick: onClickAnyDay }, intl.getLabel('appointments.timeSearch.label.anyDay'))));
    };
    var rangeDatePicker = (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_20__[/* RangeDatePicker */ "x"], { className: "time-slot-preference__range-date-picker", startDate: startDate, endDate: endDate, onSelectStartDate: onSelectStartDate, onSelectEndDate: onSelectEndDate, tooltip: intl.getLabel('appointments.timeSearch.tooltip.date'), labelStart: intl.getLabel("appointments.timeSearch.label.startDate"), labelEnd: intl.getLabel("appointments.timeSearch.label.endDate"), startDatePlaceholder: intl.getLabel("appointments.timeSearch.label." + (isMobile ? 'start' : 'startDate')), endDatePlaceholder: intl.getLabel("appointments.timeSearch.label." + (isMobile ? 'end' : 'endDate')), hideAsteriskSign: true }));
    var renderTimeSlotOptions = function () { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PreferenceOption, { className: "preference-option__any-time", active: !timeSelected, onClick: onClickAnyTime }, intl.getLabel('appointments.timeSearch.anyTime')),
        !!fromOptions.length && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PreferenceOption, { className: "preference-option__select-time", active: timeSelected, onClick: onClickSelectTime }, intl.getLabel('appointments.timeSearch.selectTime'))))); };
    var timeSlotDropdowns = (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "form-group--half" },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "form-group" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { className: "time-slot-preference__label" }, intl.getLabel('appointments.timeSearch.from')),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-slot-preference__options" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Dropdown */ "p"], { className: "time-slot-preference__dropdown", name: "from", value: activeFromOption && toLocalDateTime(activeFromOption), options: fromOptions, handleChange: handleChangeFrom }))),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "form-group" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { className: "time-slot-preference__label" }, intl.getLabel('appointments.timeSearch.till')),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-slot-preference__options" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Dropdown */ "p"], { className: "time-slot-preference__dropdown", name: "until", value: activeUntilOption && toLocalDateTime(activeUntilOption), options: untilOptions, handleChange: handleChangeUntil })))));
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('time-slot-preference', className) }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("form", { className: "time-slot-preference__form", onSubmit: function (e) { return e.preventDefault(); } },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "form-group" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-slot-preference__clear" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { className: "time-slot-preference__label" }, intl.getLabel('appointments.timeSearch.label.date')),
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ActiveTimeFilter, { show: canClearFilter, clearLabel: intl.getLabel('appointments.activeTimeFilter.clear'), onClear: onClear, icon: null })),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-slot-preference__options" }, renderDateOptions())),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "form-group" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { className: "time-slot-preference__label" }, intl.getLabel('appointments.timeSearch.time')),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-slot-preference__options" }, renderTimeSlotOptions()),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "time-slot-preference__select-range" }, rangeDatePicker)),
            !!fromOptions.length && timeSelected && timeSlotDropdowns),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "edit-panel__controls" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "time-slot-preference__button", caption: confirmButtonLabel, onClick: onSubmit }))));
};

/**
 * This function generates time slots on a day between the startDate i.e. '2019-05-20T08:00:00'
 * and the endDate with a stepsize of 15 minutes
 */
var generateTimeSlotRange = function (startDate, endDate, stepSize) {
    if (stepSize === void 0) { stepSize = 1000 * 60 * 15; }
    var start = Math.floor(startDate.getTime() / stepSize) * stepSize;
    var end = Math.ceil(endDate.getTime() / stepSize) * stepSize;
    var slots = [];
    for (var from = start, until = start + stepSize; until <= end; from = until, until += stepSize) {
        slots.push({ from: new Date(from), until: new Date(until) });
    }
    return slots;
};
// TODO: get rid of these fixed dates
var getDefaultRange = function () { return [
    parseLocalDateTime('2019-04-01T08:00:00'),
    parseLocalDateTime('2019-04-01T23:00:00'),
]; };
var useTimeSearch = function (range, today, hoursAfterFrom) {
    if (range === void 0) { range = getDefaultRange(); }
    if (today === void 0) { today = new Date(); }
    if (hoursAfterFrom === void 0) { hoursAfterFrom = 2; }
    var _a = useAppointmentBookerContext().state, timeFilter = _a.timeFilter, openTimeSearchDialog = _a.openTimeSearchDialog;
    var activeTimeFilter = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return !!openTimeSearchDialog
            ? {
                date: {
                    type: 'dynamic',
                    value: 'today',
                },
                time: {
                    type: 'any',
                },
            }
            : timeFilter;
    }, [openTimeSearchDialog]);
    var _b = __read(react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(activeTimeFilter), 2), customTimeFilter = _b[0], setCustomTimeFilter = _b[1];
    var slots = generateTimeSlotRange.apply(void 0, __spread(range));
    var fromOptions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return slots.map(function (_a) {
        var from = _a.from;
        return ({ value: toLocalDateTime(from), label: dateToLocalTime(from) });
    }); }, [slots]);
    var untilOptions = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return slots.map(function (_a) {
            var until = _a.until;
            return ({
                value: toLocalDateTime(until),
                label: dateToLocalTime(until),
            });
        });
    }, [slots]);
    var hours = hoursAfterFrom * 4; // 15 minutes for each step times 4
    var onClear = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () { return setCustomTimeFilter(activeTimeFilter); }, [activeTimeFilter]);
    var onSetActiveFrom = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (from) {
        setCustomTimeFilter(function (current) {
            var fromTimeFilter = current.time.type === 'range' && current.time.value.start;
            if (fromTimeFilter && isSameMinute(from, fromTimeFilter)) {
                return current;
            }
            var until = (current.time.type === 'range' && current.time.value.end) || slots[hours].until;
            return __assign(__assign({}, current), { type: 'range', value: {
                    start: from,
                    end: until,
                } });
        });
    }, []);
    var onSetActiveUntil = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (until) {
        setCustomTimeFilter(function (current) {
            var untilTimeFilter = current.time.type === 'range' && current.time.value.end;
            if (untilTimeFilter && isSameMinute(until, untilTimeFilter)) {
                return current;
            }
            var from = (current.time.type === 'range' && current.time.value.start) || slots[0].from;
            return __assign(__assign({}, current), { time: {
                    type: 'range',
                    value: {
                        start: from,
                        end: until,
                    },
                } });
        });
    }, []);
    var onClickToday = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        setCustomTimeFilter(function (current) {
            return __assign(__assign({}, current), { date: {
                    type: 'dynamic',
                    value: 'today',
                } });
        });
    }, []);
    var onClickTomorrow = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        setCustomTimeFilter(function (current) {
            return __assign(__assign({}, current), { date: {
                    type: 'dynamic',
                    value: 'tomorrow',
                } });
        });
    }, []);
    var onClickAnyDay = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        setCustomTimeFilter(function (current) {
            return __assign(__assign({}, current), { date: {
                    type: 'any',
                } });
        });
    }, []);
    var onClickAnyTime = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        setCustomTimeFilter(function (current) {
            return __assign(__assign({}, current), { time: {
                    type: 'any',
                } });
        });
    }, []);
    var onClickSelectTime = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        setCustomTimeFilter(function (current) {
            var start = (current.time.type === 'range' && current.time.value.start) || slots[0].from;
            var end = (current.time.type === 'range' && current.time.value.end) || slots[hours].until;
            return __assign(__assign({}, current), { time: {
                    type: 'range',
                    value: {
                        start: start,
                        end: end,
                    },
                } });
        });
    }, []);
    var onSelectStartDate = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (date) {
        setCustomTimeFilter(function (current) {
            if (current.date.type === 'range') {
                if (isSameDay(current.date.value.start, date)) {
                    return current;
                }
                var end = current.date.value.end;
                return __assign(__assign({}, current), { date: {
                        type: 'range',
                        value: {
                            start: isDateBefore(end, date) ? end : date,
                            end: end,
                        },
                    } });
            }
            else {
                if (current.date.type === 'single' && isSameDay(current.date.value, date)) {
                    return current;
                }
                return __assign(__assign({}, current), { date: {
                        type: 'single',
                        value: date,
                    } });
            }
        });
    }, []);
    var onSelectEndDate = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (date) {
        setCustomTimeFilter(function (current) {
            if (current.date.type === 'range' && isSameDay(date, current.date.value.end)) {
                return current;
            }
            return __assign(__assign({}, current), { date: {
                    type: 'range',
                    value: {
                        start: (current.date.type === 'range' && current.date.value.start) ||
                            (current.date.type === 'single' && current.date.value) ||
                            today,
                        end: current.date.type === 'range' && isDateBefore(date, current.date.value.start)
                            ? current.date.value.start
                            : date,
                    },
                } });
        });
    }, []);
    return {
        fromOptions: fromOptions,
        untilOptions: untilOptions,
        slots: slots,
        onClear: onClear,
        onSelectStartDate: onSelectStartDate,
        onSelectEndDate: onSelectEndDate,
        onClickSelectTime: onClickSelectTime,
        onClickAnyTime: onClickAnyTime,
        onClickTomorrow: onClickTomorrow,
        onClickAnyDay: onClickAnyDay,
        onClickToday: onClickToday,
        onSetActiveUntil: onSetActiveUntil,
        onSetActiveFrom: onSetActiveFrom,
        customTimeFilter: customTimeFilter,
    };
};

var TimeSlotPreferenceContainer = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var dispatchAppAction = useAppointmentBookerContext().dispatch;
    var _b = __read(useRouteState(), 2), activeRoute = _b[0], setActiveRoute = _b[1];
    var _c = useTimeSearch(undefined, new Date(), 2), customTimeFilter = _c.customTimeFilter, fromOptions = _c.fromOptions, untilOptions = _c.untilOptions, slots = _c.slots, onSelectStartDate = _c.onSelectStartDate, onSelectEndDate = _c.onSelectEndDate, onClear = _c.onClear, onClickSelectTime = _c.onClickSelectTime, onClickAnyTime = _c.onClickAnyTime, onClickTomorrow = _c.onClickTomorrow, onClickAnyDay = _c.onClickAnyDay, onClickToday = _c.onClickToday, onSetActiveUntil = _c.onSetActiveUntil, onSetActiveFrom = _c.onSetActiveFrom;
    var confirmButtonLabel = activeRoute === 'type'
        ? intl.getLabel('appointments.timeSearch.searchAvailability')
        : intl.getLabel('appointments.timeSearch.apply');
    var isTodayActive = customTimeFilter.date.type === 'dynamic' && customTimeFilter.date.value === 'today';
    var isTomorrowActive = customTimeFilter.date.type === 'dynamic' && customTimeFilter.date.value === 'tomorrow';
    var isAnyDayActive = customTimeFilter.date.type === 'any';
    var hasActiveRange = Boolean(customTimeFilter.date.type === 'range' &&
        customTimeFilter.date.value.start &&
        customTimeFilter.date.value.end);
    var hasSingleDate = Boolean(customTimeFilter.date.type === 'single' && customTimeFilter.date.value);
    var timeSelected = Boolean(customTimeFilter.time.type === 'range' && customTimeFilter.time.value.start);
    var canClearFilter = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () {
        return isTomorrowActive || isAnyDayActive || timeSelected || hasActiveRange || hasSingleDate;
    }, [isTomorrowActive, isAnyDayActive, hasActiveRange, timeSelected, hasSingleDate]);
    var startDate = (customTimeFilter.date.type === 'range' && customTimeFilter.date.value.start) ||
        (customTimeFilter.date.type === 'single' && customTimeFilter.date.value) ||
        undefined;
    var endDate = (customTimeFilter.date.type === 'range' && customTimeFilter.date.value.end) || undefined;
    var activeFromOption = (customTimeFilter.time.type === 'range' && customTimeFilter.time.value.start) || undefined;
    var activeUntilOption = (customTimeFilter.time.type === 'range' && customTimeFilter.time.value.end) || undefined;
    var handleChangeFrom = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (_a) {
        var value = _a.value;
        onSetActiveFrom(parseLocalDateTime(value));
    }, [onSetActiveFrom]);
    var handleChangeUntil = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (_a) {
        var value = _a.value;
        onSetActiveUntil(parseLocalDateTime(value));
    }, [onSetActiveUntil]);
    var handleSubmit = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        dispatchAppAction({ type: 'SET_TIME_FILTER', payload: customTimeFilter });
        dispatchAppAction({ type: 'RESET_TIME_SEARCH_DIALOG_OPEN' });
        activeRoute === 'timeslot' &&
            startDate &&
            dispatchAppAction({
                type: 'SET_SELECTED_DATE',
                payload: startDate,
            });
        setActiveRoute(activeRoute === 'type' ? 'store' : 'timeslot');
    }, [customTimeFilter]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TimeSlotPreference, __assign({}, rest, { activeFromOption: activeFromOption, activeUntilOption: activeUntilOption, startDate: startDate, endDate: endDate, canClearFilter: canClearFilter, timeSelected: timeSelected, isTomorrowActive: isTomorrowActive, isTodayActive: isTodayActive, isAnyDayActive: isAnyDayActive, hasActiveRange: hasActiveRange, confirmButtonLabel: confirmButtonLabel, onClear: onClear, onClickToday: onClickToday, onClickTomorrow: onClickTomorrow, onClickAnyDay: onClickAnyDay, onClickSelectTime: onClickSelectTime, onClickAnyTime: onClickAnyTime, fromOptions: fromOptions, untilOptions: untilOptions, handleChangeFrom: handleChangeFrom, handleChangeUntil: handleChangeUntil, onSelectStartDate: onSelectStartDate, onSelectEndDate: onSelectEndDate, slots: slots, onSubmit: handleSubmit })));
};

var TimeSearchDialog = function (_a) {
    var onClose = _a.onClose;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { className: "time-search-dialog", isOpen: true, showIcon: true, title: intl.getLabel('appointments.timeSearchDialog.title'), onModalClose: onClose, useScrollLock: false },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TimeSlotPreferenceContainer, null)));
};

var TimeSearchDialogContainer = function (props) {
    var dispatchAppAction = useAppointmentBookerContext().dispatch;
    var handleClose = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () { return dispatchAppAction({ type: 'RESET_TIME_SEARCH_DIALOG_OPEN' }); }, []);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TimeSearchDialog, __assign({}, props, { onClose: handleClose }));
};

var routeMap = {
    type: StepSelectTypeContainer,
    store: StoreSelectionContainer,
    timeslot: StepSelectDateContainer,
    details: StepDetailsOverviewContainerWithChecksContext,
    completed: ConfirmationContainer,
};
var AppointmentBookerContainer = function (_a) {
    var _b;
    var apiUrl = _a.apiUrl, asPath = _a.asPath, currentRoute = _a.currentRoute, urlQueryParams = _a.queryParams, router = _a.router, form = _a.form, signInMyAccountUrl = _a.signInMyAccountUrl, rest = __rest(_a, ["apiUrl", "asPath", "currentRoute", "queryParams", "router", "form", "signInMyAccountUrl"]);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_4__[/* useIntl */ "Q"])();
    var _c = useAppointmentBookerContext(), appState = _c.state, dispatchAppAction = _c.dispatch, basePath = _c.basePath, loadingUser = _c.loadingUser;
    var mapState = useMapContext().state;
    var openEditPanel = appState.openEditPanel, openTimeSearchDialog = appState.openTimeSearchDialog, allowOverflow = appState.allowOverflow, selectedAppointmentType = appState.selectedAppointmentType, selectedStore = appState.selectedStore, selectedDate = appState.selectedDate, selectedTimeSlot = appState.selectedTimeSlot, typeFilter = appState.typeFilter, isRescheduling = appState.isRescheduling, reschedulingFailed = appState.reschedulingFailed, bookedAppointment = appState.bookedAppointment, hasCompleted = appState.hasCompleted;
    var showMap = mapState.showMap;
    var _d = __read(useRouteState(), 2), activeRoute = _d[0], setActiveRoute = _d[1];
    var queryParams = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return (Object.entries(urlQueryParams).length ? urlQueryParams : {}); }, [urlQueryParams]);
    var routes = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return __spread([basePath], Object.keys(routeMap).map(function (key) { return basePath + "/" + key; })); }, [basePath]);
    var basePathForSignup = basePath.replace('/', '');
    var renderRouteComponent = function (route) {
        switch (route) {
            case 'type':
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(routeMap[route], { apiUrl: apiUrl });
            case 'store':
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(routeMap[route]);
            case 'timeslot':
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(routeMap[route], { apiUrl: apiUrl });
            case 'details':
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(routeMap[route], {
                    apiUrl: apiUrl,
                    form: form,
                    loadOptIns: true,
                    signInMyAccountUrl: window.location.origin + "/" + signInMyAccountUrl + "?returnPath=" + basePathForSignup + "/details",
                });
            case 'completed':
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(routeMap[route]);
        }
    };
    var isFullScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint() !== _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var onBeforeUnload = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (event) {
        if (hasCompleted) {
            // Make sure we clear the has completed state of the user, since otherwise users can't book any successive appointments
            dispatchAppAction({ type: 'RESET' });
        }
        else {
            // Make sure we clear the rescheduling state before the user leaves so we start with a clean state later
            dispatchAppAction({ type: 'RESET_RESCHEDULING' });
        }
    }, [hasCompleted]);
    Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* useBeforeunload */ "H"])(onBeforeUnload);
    // Set a handler for app related onpopstate history events
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        var options = {
            cancelled: false,
        };
        router.beforePopState(function (_a) {
            var as = _a.as;
            var _b = __read(as.split('?'), 2), preQuery = _b[0], queryString = _b[1];
            var isAabRoute = routes.includes(preQuery);
            if (isAabRoute) {
                var route = preQuery.replace(basePath + "/", '');
                var queryParams_1 = queryString ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* QueryString */ "e"].parse(queryString) : {};
                Object.assign(options, { apiUrl: apiUrl, fromPopState: true, queryParams: queryParams_1 });
                setActiveRoute(route || '', options);
            }
            return !isAabRoute;
        });
        return function () {
            options.cancelled = true;
        };
    }, []);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        dispatchAppAction({
            type: 'setState',
            key: 'queryParams',
            value: queryParams && Object.entries(queryParams).length ? queryParams : undefined,
        });
    }, [queryParams]);
    // Replace the current route when the url doesn't fit the state of the application
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        if (loadingUser) {
            return;
        }
        var validatedRoute = getValidatedRoute(appState, currentRoute, queryParams);
        var didQueryParamsChange = hasNewQueryParams(appState.queryParams, queryParams);
        var options = { replace: true, queryParams: queryParams, apiUrl: apiUrl, cancelled: false };
        if (!currentRoute ||
            validatedRoute !== currentRoute ||
            validatedRoute !== activeRoute ||
            didQueryParamsChange) {
            setActiveRoute(validatedRoute, options);
        }
        return function () {
            options.cancelled = true;
        };
    }, [loadingUser]);
    react__WEBPACK_IMPORTED_MODULE_0___default.a.useEffect(function () {
        var route = activeRoute;
        if (openEditPanel) {
            route = 'edit';
        }
        if (openTimeSearchDialog) {
            route = 'searchTime';
        }
        if (openEditPanel && Boolean(selectedDate) && activeRoute === 'timeslot') {
            route = 'searchStoreForTime';
        }
        var action = isRescheduling ? 'change' : 'new';
        var dataLayerEvent = createAppointmentEvent(action, route, selectedAppointmentType, typeFilter, selectedStore, selectedTimeSlot);
        if (dataLayerEvent) {
            _grandvision_analytics__WEBPACK_IMPORTED_MODULE_2__[/* DataLayer */ "g"].pushEvent(dataLayerEvent);
        }
    }, [activeRoute, openEditPanel, openTimeSearchDialog, isRescheduling]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentBooker, __assign({}, rest, { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_b = {},
            _b["appointment-booker--" + activeRoute] = !!activeRoute,
            _b['appointment-booker--allow-overflow'] = allowOverflow,
            _b)), apiUrl: apiUrl, isFullScreen: isFullScreen, showMap: showMap, showInfoBar: activeRoute ? ['type', 'store', 'timeslot'].includes(activeRoute) : false, confirmationImageUrl: intl.getLabel('appointments.selectionSteps.confirmationImageUrl') }), reschedulingFailed ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "appointment-booker__rescheduling-failed" },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", className: "appointment-booker__reschedule-alert", title: intl.getLabel('appointments.rescheduling.failed.alert.title'), message: intl.getLabel('appointments.rescheduling.failed.alert.message') }),
        queryParams.returnPath && queryParams.returnLabel && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "appointment-booker__return-button", caption: queryParams.returnLabel
                ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('returnLabel', queryParams.returnLabel, '')
                : undefined, href: queryParams.returnPath
                ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_5__[/* StringGuard */ "f"].guard('returnPath', queryParams.returnPath, '')
                : undefined })))) : (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
        openEditPanel && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(EditPanelContainer, null),
        openTimeSearchDialog && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TimeSearchDialogContainer, null),
        isRescheduling && bookedAppointment && activeRoute === 'timeslot' && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RescheduleAlert, { timeSlot: {
                from: parseLocalDateTime(bookedAppointment.startTime),
                until: parseLocalDateTime(bookedAppointment.endTime),
            } })),
        activeRoute ? renderRouteComponent(activeRoute) : null))));
};

var AppointmentBookerRoot = function (_a) {
    var apiUrl = _a.apiUrl, _b = _a.consents, consents = _b === void 0 ? [] : _b, _c = _a.optIns, optIns = _c === void 0 ? [] : _c, asPath = _a.asPath, currentRoute = _a.currentRoute, labels = _a.labels, queryParams = _a.queryParams, router = _a.router, _d = _a.signInMyAccountUrl, signInMyAccountUrl = _d === void 0 ? 'my-account/login' : _d, children = _a.children, _e = _a.featureToggles, featureToggles = _e === void 0 ? {
        withAvailabilityOnStoreSelection: false,
        withTimeSlotByWeekCheck: false,
        withTimeSearch: false,
        storeSearchEnabled: false,
    } : _e;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentBookerProvider$1, { isMyAccountEnabled: true, consents: consents, optIns: optIns, asPath: asPath, featureToggles: {
            withAvailabilityOnStoreSelection: !!featureToggles.withAvailabilityOnStoreSelection,
            withTimeSlotByWeekCheck: !!featureToggles.withTimeSlotByWeekCheck,
            withTimeSearch: !!featureToggles.withTimeSearch,
            storeSearchEnabled: !!featureToggles.storeSearchEnabled,
        } },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentTypeProvider, { apiUrl: apiUrl },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StoresProvider, { apiUrl: apiUrl },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MapProvider, null,
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(AppointmentBookerContainer, { apiUrl: apiUrl, labels: labels, asPath: asPath, currentRoute: currentRoute, queryParams: queryParams, router: router, signInMyAccountUrl: signInMyAccountUrl, form: getFormFromRoot(children) }))))));
};
var getFormFromRoot = function (children) {
    var formWrapper = react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.toArray(children).find(function (child) { return react__WEBPACK_IMPORTED_MODULE_0___default.a.isValidElement(child) && child.type === Form; });
    return formWrapper && react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(formWrapper.props.children);
};
var Form = function () { return null; };
AppointmentBookerRoot.Form = Form;


//# sourceMappingURL=index.es.js.map


/***/ })

}]);